import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import ZoomDropdown from "../components/ZoomDropdown";
import logo from "../assets/logo.png";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import EditIcon from "@mui/icons-material/Edit";
import pbformImg from "../assets/pbFormWelcom.png";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  Grid2,
  Box,
  Slider,
  Typography,
  Button,
  TextField,
  IconButton,
  DialogContent,
  DialogTitle,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  DialogActions,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import SignatureModalContent from "../components/SignatureModalContent";
import { format, parse, isValid } from "date-fns";
import FileUpload from "../components/FileUpload";
import "../styles/App.styles.css";
import "../App.css";
import { Rnd } from "react-rnd";
import ImageUploader from "../components/ImageUploader";
import TabsComponent from "../components/TabsComponent";
import ForYou from "../components/ForYou";
import ForOthers from "../components/ForOthers";
import TextPropertiesPanel from "../components/TextPropertiesPanel";
import DatePickerComponent from "../components/DatePickerComponent";
import ImageCropperModal from "../components/ImageCropperModal";
import AddIcon from "@mui/icons-material/Add";
import SignersDialog from "../components/SignersDialog";
import SignerFieldProperties from "../components/SignerFieldProperty";
import TextEntryDialog from "../components/TextEntryDialog";
import ShrinkToFitText from "../components/ShrinkToFitText";
import {
  colorWithAlpha,
  downloadPdfWithTextAnnotations,
  downloadOriginalPdf,
  getColorWithNewOpacity,
  getColorWithCustomOpacity,
  getDateFieldBoxLayout,
  getSignerBoxContent,
  hashIds,
  unhashIds,
} from "../components/utlis";
import {
  getUserLocation,
  post,
  postFormData,
  termsConditions,
  websiteBaseUrl,
} from "../apis/apis";
import { setActiveRegion, DEFAULT_REGION, getRegion } from "../configs/regionConfig";
import { refreshRegionExports, getApiBaseUrl } from "../apis/apis";

import DropdownPropertiesPanel from "../components/DropdownPropertiesPanel";
import toastAlert from "../components/toastAlert";
import getActivityLogUserFiles from "../components/getActivityLogUserFiles";
import { useParams } from "react-router-dom";
import AccessCodeDialog from "../components/AccessCodeDialog";
import ErrorModal from "../components/ErrorModal";
import {
  acroformFieldsToAnnotations,
  groupAnnotationsByPage,
} from "../utlis/acroformToAnnotations";
import WaitForOthersDialog from "../components/WaitForOthersDialog";
import CompletionModal from "../components/CompletionModal";
import logoRemoveBg from "../assets/logo.png";
import ExpiredLinkModal from "../components/ExpiredLinkModal";
import VerificationDialog from "../components/VerificationDialog";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import getActivityLogUserBulk from "../components/MaintainActivityLogBulk";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

function EsignReceivingEndPublicForm() {
  const normalizeTextValue = (value) =>
    typeof value === "string" ? value.trim() : "";

  const isTextPlaceholderValue = (value) => {
    const normalized = normalizeTextValue(value).toLowerCase();
    return (
      normalized === "" ||
      normalized === "enter text" ||
      normalized === "click to enter text" ||
      normalized === "tap to enter text" ||
      normalized === "type here..." ||
      normalized === "type your text here..."
    );
  };

  const resolveFieldLabel = (annotation = {}) => {
    const candidates = [
      annotation.fieldLabel,
      annotation.field_label,
      annotation.label,
      annotation.field_label_text,
      annotation.fieldName,
      annotation.field_name,
    ];
    return candidates.find((item) => normalizeTextValue(item)) || "";
  };

  const getSignerColorById = (signerId, signers) => {
    const signer = signers.find(
      (s) => s.signer_id === signerId || s.id === signerId
    );
    return signer?.color || "rgba(0, 0, 0, 0.1)"; // Default color if signer not found
  };
  const [pageSizes, setPageSizes] = useState({});

  const [agreed, setAgreed] = useState(false);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [welcomeMessage, setWelcomeMessage] = useState("");
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState("");
  const [ResponseLimitCompleted, setResponseLimitCompleted] = useState(false);
  // const [AverificationNeededccessCodeModal, setAccessCodeModal] = useState(true);
  const [expiredLink, setExpiredLink] = useState(false);
  const [verificationNeeded, setVerificationNeeded] = useState(false);
  const [verificationOTP, setVerificationOTP] = useState(false);
  const [loaderData, setLoaderData] = useState(false);
  const [code, setCode] = useState("");
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    agreed: false,
  });
  const handleSubmit = () => {
    const newErrors = {
      name: !name.trim(),
      email: !email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
      agreed: !agreed,
    };
    setErrors(newErrors);

    if (!newErrors.name && !newErrors.email && !newErrors.agreed) {
      console.log("Form submitted");
      // Proceed with submission
      setCurrentSignerName(name);
      setCurrentSignerEmail(email);
      setOpen(false);
    }
  };
  // The encrypted IDs are the last two parts of the path
  const file_id = window.location.pathname.split("/")[3];
  const emailData = window.location.pathname.split("/")[3];
  const signerId = window.location.pathname.split("/")[4];
  // const { emailHashed, file_id, senderId, token } = useParams();
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isMobileLandscape, setIsMobileLandscape] = useState(false);
  const [isMobilePortrait, setIsMobilePortrait] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(() => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0
  }));

  const effectiveIsMobileLandscape = useMemo(() => {
    if (!isMobile) return false;
    if (isMobileLandscape) return true;
    const width = windowDimensions.width;
    const height = windowDimensions.height;
    return width > height && width >= 600;
  }, [isMobile, isMobileLandscape, windowDimensions]);

  useEffect(() => {
    if (!isMobile) {
      setIsMobileLandscape(false);
      setIsMobilePortrait(false);
      return;
    }

    const checkOrientation = () => {
      const mediaQueryLandscape = window.matchMedia('(orientation: landscape)');
      const mediaQueryPortrait = window.matchMedia('(orientation: portrait)');
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const dimensionBasedLandscape = windowWidth > windowHeight;
      const isChrome = /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent);
      let isLandscape, isPortrait;

      if (isChrome) {
        isLandscape = dimensionBasedLandscape && windowWidth >= 600;
        isPortrait = !isLandscape;
      } else {
        isLandscape = mediaQueryLandscape.matches || (dimensionBasedLandscape && windowWidth >= 600);
        isPortrait = mediaQueryPortrait.matches || (!dimensionBasedLandscape || windowWidth < 600);
      }

      setIsMobileLandscape(isLandscape);
      setIsMobilePortrait(isPortrait);
    };

    setTimeout(checkOrientation, 0);
    setTimeout(checkOrientation, 100);
    setTimeout(checkOrientation, 300);

    const mediaQueryLandscape = window.matchMedia('(orientation: landscape)');
    const mediaQueryPortrait = window.matchMedia('(orientation: portrait)');

    const handleOrientationChange = () => {
      setTimeout(checkOrientation, 0);
      setTimeout(checkOrientation, 100);
    };

    if (mediaQueryLandscape.addEventListener) {
      mediaQueryLandscape.addEventListener('change', handleOrientationChange);
      mediaQueryPortrait.addEventListener('change', handleOrientationChange);
    } else {
      mediaQueryLandscape.addListener(handleOrientationChange);
      mediaQueryPortrait.addListener(handleOrientationChange);
    }

    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        checkOrientation();
        setTimeout(checkOrientation, 50);
      }, 50);
    };
    window.addEventListener('resize', handleResize);

    window.addEventListener('orientationchange', () => {
      checkOrientation();
      setTimeout(checkOrientation, 0);
      setTimeout(checkOrientation, 100);
      setTimeout(checkOrientation, 300);
      setTimeout(checkOrientation, 500);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => {
        setTimeout(checkOrientation, 0);
        setTimeout(checkOrientation, 100);
      });
    }

    return () => {
      if (mediaQueryLandscape.removeEventListener) {
        mediaQueryLandscape.removeEventListener('change', handleOrientationChange);
        mediaQueryPortrait.removeEventListener('change', handleOrientationChange);
      } else {
        mediaQueryLandscape.removeListener(handleOrientationChange);
        mediaQueryPortrait.removeListener(handleOrientationChange);
      }
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleOrientationChange);
      }
      if (resizeTimeout) clearTimeout(resizeTimeout);
    };
  }, [isMobile]);

  useEffect(() => {
    const updateDimensions = () => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      setWindowDimensions(prev => {
        if (prev.width !== newWidth || prev.height !== newHeight) {
          return { width: newWidth, height: newHeight };
        }
        return prev;
      });

      const isChrome = /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent);
      if (isChrome && isMobile) {
        const isLandscape = newWidth > newHeight && newWidth >= 600;
        setIsMobileLandscape(isLandscape);
        setIsMobilePortrait(!isLandscape);
      }
    };

    updateDimensions();
    setTimeout(updateDimensions, 50);
    setTimeout(updateDimensions, 200);

    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      updateDimensions();
      resizeTimer = setTimeout(updateDimensions, 100);
    };
    window.addEventListener('resize', handleResize);

    const handleOrientationChange = () => {
      updateDimensions();
      setTimeout(updateDimensions, 0);
      setTimeout(updateDimensions, 50);
      setTimeout(updateDimensions, 100);
      setTimeout(updateDimensions, 300);
      setTimeout(updateDimensions, 500);
    };
    window.addEventListener('orientationchange', handleOrientationChange);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateDimensions);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updateDimensions);
      }
      clearTimeout(resizeTimer);
    };
  }, [isMobile]);

  const [compLogo, setCompLogo] = useState("");
  const [compPrimaryColor, setCompPrimaryColor] = useState("");
  // Add new state at the top of App component
  const [signerToEdit, setSignerToEdit] = useState(null);
  const [pageNoClicked, setPageNoClicked] = useState(null);
  const styles = {
    sidebarStyle: {
      cursor: "default !important",
      "& *": {
        cursor: "default !important",
      },
      "& button": {
        cursor: "pointer !important",
      },
      "& .thumbnail-container": {
        cursor: "pointer !important",
      },
    },
  };
  const isSignatureType = (type) =>
    ["signer_initials", "signer_initials_text"].includes(type);
  // Add this helper function to determine if it's an image upload type
  const isImageUploadType = (type) =>
    [
      "signer_chooseImgStamp",
      "signer_chooseImgDrivingL",
      "signer_chooseImgPassportPhoto",
    ].includes(type);

  const colortheme = "rgb(35, 179, 232)";
  const [pdfFile, setPdfFile] = useState(null);
  const [scale, setScale] = useState(1); // Changed initial scale to 0.8
  const [pdfImages, setPdfImages] = useState([]);
  const [containerWidth, setContainerWidth] = useState(0);
  const [activePage, setActivePage] = useState(1); // Track active page
  const [firstPageHeight, setFirstPageHeight] = useState(null);
  // At the top with other state declarations
  const [annotationType, setAnnotationType] = useState(null); // 'text' or 'image'
  // Modify the annotations state to store per-page annotations
  const [annotations, setAnnotations] = useState({}); // Changed from array to object with page keys
  const [isAnnotating, setIsAnnotating] = useState(false);
  const [focusedAnnotation, setFocusedAnnotation] = useState(null);
  const [active, setActive] = useState("1");
  const [isZoomed, setIsZoomed] = useState(false); // Track if PDF is zoomed for mobile

  const [selectedSigner, setSelectedSigner] = useState({
    signer_id: 1,
    id: 1,
    name: "Signer",
    email: "",
    color: "rgb(255 226 139 / 98%)",
  });
  // First, add a state for storing click position
  const [stampClickPosition, setStampClickPosition] = useState(null);
  // Add this state in your App component
  const [signersDialogOpen, setSignersDialogOpen] = useState(false);
  const [signers, setSigners] = useState([
    {
      signer_id: 1,
      id: 1,
      name: "Signer",
      email: "",
      color: "rgb(255 226 139 / 98%)",
    },
  ]);
  // Inside your App.js, add this state
  const [selectedSignerId, setSelectedSignerId] = useState(null);
  // Add these helper functions

  // Add these states in your App component
  const [signatureModalOpen, setSignatureModalOpen] = useState(false);

  const [originalImageDimensions, setOriginalImageDimensions] = useState({});

  // 2. Create a function to get image dimensions when loaded
  const getImageDimensions = (imageUrl) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight,
        });
      };
      img.src = imageUrl;
    });
  };
  const [initialsBox, setInitialBox] = useState(false);
  const pdfContainerRef = useRef(null);
  const sidebarRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  // Add this component inside your EsignReceivingEndPublicForm component
  const FullScreenLoader = () => (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(3, 3, 3, 0.8)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: "rgb(35, 179, 232)",
          marginBottom: 2,
        }}
      />
      <Typography variant="h6" color="textSecondary" style={{ color: "white" }}>
        Loading Document...
      </Typography>
    </Box>
  );

  // Add new state at the top of your App component
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);

  const annotationRefs = useRef({}); // Store refs for each annotation
  const cursorRef = useRef(null);
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [activeAnnotationId, setActiveAnnotationId] = useState(null);

  const textAnnotationTypes = ["my_text", "signer_text", "date"];
  // states
  const [fileName, setFileName] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [securedShare, setSecuredShare] = useState(false);
  const [statusFile, setStatusFile] = useState("");
  const [uniqIdDoc, setUniqIdDoc] = useState("");
  const [fileUserid, setFileUserid] = useState("");
  const [docSignerStatusModal, setDocSignerStatusModal] = useState(false);
  const [all_recipientsData, setAll_RecipientsData] = useState([]);
  const [SignersWhoHaveCompletedSigning, setSignersWhoHaveCompletedSigning] =
    useState([]);
  const [errorModal, setErrorModal] = useState(false);

  const [DocSignerStatus, setDocSignerStatus] = useState(false);
  const [waitforOtherusers, setWaitforOtherusers] = useState(false);
  const [waitOtherModal, setWaitOtherModal] = useState(false);

  const [activeSignerId, setActiveSignerId] = useState("");

  const isTextAnnotation = textAnnotationTypes?.includes(annotationType);
  const selectedAnnotationType =
    textAnnotationTypes.includes(selectedAnnotation);
  const [stampInputRef] = useState(React.createRef());
  // Add these states at the top of your App component
  const [cropperModalOpen, setCropperModalOpen] = useState(false);
  const [cropSrc, setCropSrc] = useState(null);
  const [pendingStampAction, setPendingStampAction] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [activeAnnot, setActiveAnnot] = useState(null);
  const [inputText, setInputText] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);

  const handleAnnotClick = (pageNum, index, type) => {
    setActiveAnnot({ pageNum, index });
    setInputValue(annotations[pageNum][index]?.text || "");
    setAnnotationType(type);
    if (type === "signer_dropdown" && annotations[pageNum][index]?.options) {
      setDropdownOptions(annotations[pageNum][index].options);
    }
    setModalOpen(true);
  };
  const [maxChars, setMaxChars] = useState(50); // Default max length

  // Text entry modal (same as EsignReceivingEnd - box + dialog for my_text, signer_text, date)
  const [textEntryDialogOpen, setTextEntryDialogOpen] = useState(false);
  const [textEntryInitialText, setTextEntryInitialText] = useState("");
  const [textEntryPlaceholder, setTextEntryPlaceholder] = useState(
    "Type your text here..."
  );
  const [editingTextAnnotation, setEditingTextAnnotation] = useState(null);
  const handleEditText = (pageNum, index, annot) => {
    setEditingTextAnnotation({ pageNum, index });
    setTextEntryInitialText(annot?.text || "");
    setTextEntryPlaceholder(
      annot?.fieldLabel?.trim() || "Type your text here..."
    );
    setTextEntryDialogOpen(true);
  };
  const handleTextEntryCancel = () => {
    setTextEntryDialogOpen(false);
    setEditingTextAnnotation(null);
    setTextEntryInitialText("");
    setTextEntryPlaceholder("Type your text here...");
  };
  const handleTextEntryComplete = (enteredText) => {
    if (!editingTextAnnotation) {
      handleTextEntryCancel();
      return;
    }
    const MAX_CHARACTERS = 500;
    const textToUse = (enteredText && enteredText.trim())
      ? (enteredText.length > MAX_CHARACTERS ? enteredText.substring(0, MAX_CHARACTERS) : enteredText)
      : "";
    const { pageNum, index } = editingTextAnnotation;
    setAnnotations((prev) => {
      const pageAnns = [...(prev[pageNum] || [])];
      if (pageAnns[index]) {
        const currentAnnotation = pageAnns[index];
        pageAnns[index] = { ...currentAnnotation, text: textToUse };
      }
      return { ...prev, [pageNum]: pageAnns };
    });
    handleTextEntryCancel();
  };

  useEffect(() => {
    if (modalOpen && annotationType === "signer_text") {
      // Delay to ensure ref is available
      setTimeout(() => {
        const inputEl = document.querySelector(".MuiDialogContent-root input");
        if (!inputEl) return;

        // Get the font styles
        const computedStyle = window.getComputedStyle(inputEl);

        // Create a hidden span to measure text width
        const span = document.createElement("span");
        span.style.cssText = `
            visibility: hidden;
            position: fixed;
            font-family: ${computedStyle.fontFamily};
            font-size: ${computedStyle.fontSize};
            font-weight: ${computedStyle.fontWeight};
            font-style: ${computedStyle.fontStyle};
            letter-spacing: ${computedStyle.letterSpacing};
            white-space: pre;
            padding: ${computedStyle.padding};
          `;

        document.body.appendChild(span);

        // Available width for text input
        const containerWidth = inputEl.offsetWidth - 8; // Account for padding
        let allowedChars = 0;

        // Incrementally add characters until it exceeds width
        for (let i = 1; i <= 100; i++) {
          span.innerText = "W".repeat(i); // Use a wide character
          if (span.getBoundingClientRect().width > containerWidth) break;
          allowedChars = i;
        }

        document.body.removeChild(span);
        setMaxChars(allowedChars);
      }, 100);
    }
  }, [modalOpen, annotationType]);
  const handleSaveInput = () => {
    if (activeAnnot) {
      const { pageNum, index } = activeAnnot;
      setAnnotations((prev) => {
        const updatedAnnotations = { ...prev };
        updatedAnnotations[pageNum][index].text = inputValue;
        return updatedAnnotations;
      });
      setModalOpen(false);
    }
  };
  // Function to enforce max length
  const handleDialogInputChange = (e) => {
    if (e.target.value.length <= maxChars) {
      setInputValue(e.target.value);
    }
  };
  const handleStampFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      setCropSrc(e.target.result);
      setPendingStampAction({
        isEdit: !!editingAnnotation,
        editData: editingAnnotation,
        newStampPosition: stampClickPosition,
      });
      setCropperModalOpen(true);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };
  // Add handler for cropped image - upload to API (same as EsignReceivingEnd)
  const handleCroppedStamp = async (croppedImage) => {
    const action = pendingStampAction;
    if (!action) {
      setCropperModalOpen(false);
      setCropSrc(null);
      setStampClickPosition(null);
      setEditingAnnotation(null);
      return;
    }

    const isEdit = action.isEdit && action.editData;
    const editData = action.editData;

    try {
      const base64Response = await fetch(croppedImage);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "image.png", { type: "image/png" });

      const postData = {
        image: fileObject,
        user_id: user_idSender,
      };

      const apiData = await postFormData(postData);

      if (!apiData.public_url) {
        toastAlert("error", "Error uploading image");
        return;
      }

      const imageUrl = apiData.public_url;

      if (isEdit && editData) {
        const { pageNum, index } = editData;
        setAnnotations((prev) => {
          const updatedAnnotations = { ...prev };
          const existingAnnot = updatedAnnotations[pageNum]?.[index];
          if (existingAnnot) {
            updatedAnnotations[pageNum] = [...(updatedAnnotations[pageNum] || [])];
            updatedAnnotations[pageNum][index] = {
              ...existingAnnot,
              imageUrl,
            };
          }
          return updatedAnnotations;
        });
        setEditingAnnotation(null);
      } else {
        const newAnnotation = {
          id: Date.now(),
          x: action.newStampPosition?.x ?? 0,
          y: action.newStampPosition?.y ?? 0,
          type: "stamp",
          page_no: pageNoClicked,
          imageUrl,
        };

        setAnnotations((prev) => {
          const page = pageNoClicked ?? activePage;
          const updatedAnnotations = {
            ...prev,
            [page]: [...(prev[page] || []), newAnnotation],
          };
          const newIndex = updatedAnnotations[page].length - 1;
          setActiveAnnotation(`${page}-${newIndex}`);
          return updatedAnnotations;
        });
      }

      setCropperModalOpen(false);
      setCropSrc(null);
      setPendingStampAction(null);
      setStampClickPosition(null);
    } catch (error) {
      console.error("Error uploading image:", error);
      toastAlert("error", "Error uploading image");
    }
  };
  const calculateZoomPercentage = useCallback((scaleValue) => {
    // return Math.round((scaleValue / 0.8) * 100);
    return Math.round(scaleValue * 100);
  }, []);

  // const calculateImageWidth = useCallback(
  //   (scaleValue) => {
  //     const baseWidth = 80;
  //     const zoomPercentage = calculateZoomPercentage(scaleValue);
  //     return Math.max(baseWidth * (zoomPercentage / 100), 50);
  //   },
  //   [calculateZoomPercentage]
  // );
  const calculateImageWidth = useCallback((scaleValue) => {
    // Use a fixed maximum width approach instead of viewport-dependent scaling
    const containerWidth =
      pdfContainerRef.current?.offsetWidth || window.innerWidth * 0.8;
    const maxPdfWidth = containerWidth * 0.95; // 95% of container width

    // Base PDF width should be consistent
    const basePdfWidth = Math.min(800, maxPdfWidth); // Max 800px base width

    // Apply scale factor
    const scaledWidth = basePdfWidth * scaleValue;

    // Convert to percentage of container
    return Math.min(95, (scaledWidth / containerWidth) * 100);
  }, []);
  // Memoize container width update
  const updateContainerWidth = useCallback(() => {
    if (pdfContainerRef.current) {
      setContainerWidth(pdfContainerRef.current.offsetWidth);
    }
  }, []);
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // check

  useEffect(() => {
    const pdfContainer = pdfContainerRef.current;
    if (!pdfContainer) return;

    const handleScroll = debounce((e) => {
      const container = e.target;
      const containerRect = container.getBoundingClientRect();
      const elements = document.querySelectorAll(".pdf-page-container");

      let detectedPage = null;

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isVisible =
          rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;

        if (isVisible && !detectedPage) {
          detectedPage = parseInt(element.id.split("-")[1]);
        }
      });

      if (detectedPage) {
        setActivePage(detectedPage);
      }
    }, 16); // 60fps debounce

    pdfContainer.addEventListener("scroll", handleScroll);
    return () => pdfContainer.removeEventListener("scroll", handleScroll);
  }, []);

  const setupIntersectionObserver = useCallback((options) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.5) {
            const pageNum = parseInt(entry.target.id.split("-")[1]);
            setActivePage(pageNum);
          }
        });
      },
      {
        ...options,
        threshold: [0.5], // Fire when 50% of page is visible
      }
    );

    document.querySelectorAll(".pdf-page-container").forEach((element) => {
      observer.observe(element);
    });

    return observer;
  }, []);

  const scrollThumbnailIntoView = (pageNum) => {
    const thumbnailElement = document.getElementById(`thumbnail-${pageNum}`);

    if (thumbnailElement && sidebarRef.current) {
      thumbnailElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };
  useEffect(() => {
    // if (sidebarVisible) {
    scrollThumbnailIntoView(activePage);
    // }
  }, [activePage]);
  useEffect(() => {
    const updatePageSizes = () => {
      const newSizes = {};
      pdfImages.forEach((_, pageIndex) => {
        const pageElement = document.getElementById(`img-${pageIndex + 1}`);
        if (pageElement) {
          newSizes[pageIndex + 1] = {
            width: pageElement.clientWidth,
            height: pageElement.clientHeight,
          };
        }
      });
      setPageSizes(newSizes);
    };

    updatePageSizes();

    window.addEventListener("resize", updatePageSizes);
    return () => window.removeEventListener("resize", updatePageSizes);
  }, [pdfImages, scale]);
  const handlePageHover = (pageNum) => {
    setActivePage(pageNum); // Nothing else!
  };
  // Add these constants at the top of your file
  const RESIZE_HANDLES = {
    // bottom: true,
    // bottomLeft: true,
    bottomRight: true,
    // left: true,
    // right: true,
    // top: true,
    // topLeft: true,
    // topRight: true,
  };

  // Combine container width and resize effects
  useEffect(() => {
    updateContainerWidth();
    window.addEventListener("resize", updateContainerWidth);
    return () => window.removeEventListener("resize", updateContainerWidth);
  }, [updateContainerWidth, scale]);

  const loadPdfFromUrl = async (url) => {
    try {
      const response = await fetch(url);
      const pdfBlob = await response.blob();
      console.log("loading ");
      setPdfFile(pdfBlob);
      await convertPdfToImages(pdfBlob);
    } catch (error) {
      console.error("Error loading PDF from URL:", error);
    }
  };
  // Initialize zoom state for mobile view

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedAnnotation(null);
        setAnnotationType(null);
        setIsAnnotating(false);
      }
    };

    // Add event listener when the component mounts
    document.body.addEventListener("keydown", handleKeyDown);

    // Remove event listener when the component unmounts
    return () => {
      document.body.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  // Update the convertPdfToImages function
  const convertPdfToImages = useCallback(async (file) => {
    try {
      let pdfData;
      if (file instanceof Blob) {
        // If file is already a Blob (from file upload)
        pdfData = await file.arrayBuffer();
      } else {
        // If file is a URL
        const response = await fetch(file);
        pdfData = await response.arrayBuffer();
      }

      const loadingTask = pdfjs.getDocument({ data: pdfData });
      const pdf = await loadingTask.promise;
      const images = await Promise.all(
        Array.from({ length: pdf.numPages }, async (_, i) => {
          const page = await pdf.getPage(i + 1);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({
            canvasContext: context,
            viewport,
          }).promise;

          return canvas.toDataURL("image/png");
        })
      );

      setPdfImages(images);
      setIsLoading(false);
    } catch (error) {
      console.error("Error converting PDF:", error);
    }
  }, []);
  // hashed
  const [documentId, setDocumentId] = useState(null);
  const [userId, setUserId] = useState(null);
  // Function to generate hashed URL
  const generateHashedUrl = (documentId, userId) => {
    const data = { documentId, userId };
    const hashedData = hashIds(data);
    const baseUrl = window.location.origin + window.location.pathname;
    return `${baseUrl}?data=${hashedData}`;
  };

  // Example usage:
  const shareDocument = () => {
    // fileid   user id
    const hashedUrl = generateHashedUrl("116676", "116625");
    // Now you can share this URL
    console.log("Shareable URL:", hashedUrl);
  };
  // funxtions
  const fetchFileData = async (fileId, user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      file_id: fileId,
      user_id: user_id,
    };
    const apiData = await post("file/get-file", postData); // Specify the endpoint you want to call
    console.log("File Dta Fetch");

    console.log(apiData);
    // setUniqIdDoc(apiData.data.uniq_id)
    if (apiData.error) {
      // window.location.href = "/error";
      toastAlert("error", "No File exist");
    } else {
      // toastAlert("success", "File exist")
      setFileName(apiData?.data?.name || "");

      // end
      //console.log('dfdf');
      //console.log(apiData.data.only_signer);
      setEmailMessage(
        apiData?.data?.email_message ||
        `Please review and e-sign the document ${apiData?.data?.name} at your earliest convenience. Thank you!`
      );
      setEmailSubject(`Request for Signature: ${apiData?.data?.name}`);
      setUniqIdDoc(apiData?.data?.uniq_id);
      setSecuredShare(apiData.data.secured_share || false);
      // setSignerFunctionalControls(
      //   apiData.data.signer_functional_controls || true
      // );
      // setSetEsignOrder(apiData.data.esign_order || false);
      setStatusFile(apiData.data.status || "");
    }
  };
  const [user_email, setUserEmail] = useState("");
  const fetchuser = async (user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      user_id: user_id,
    };
    const apiData = await post("user/getUser1ById", postData); // Specify the endpoint you want to call
    console.log("get user");

    console.log(apiData);
    // setUniqIdDoc(apiData.data.uniq_id)
    if (apiData.error) {
      // window.location.href = "/error";
      toastAlert("error", "No USER exist");
    } else {
      setUserEmail(apiData?.result[0]?.email || "");
      // toastAlert("success", "File exist")
    }
  };
  // const UpdateLastChange = async (fileId) => {
  //   const location = await getUserLocation();
  //   const postData = {
  //     file_id: fileId,
  //     last_change: location?.date,
  //   };
  //   try {
  //     const apiData = await post("file/updateLastChange", postData); // Specify the endpoint you want to call
  //     console.log("Update Last Change");

  //     console.log(apiData);
  //   } catch (error) {
  //     //console.log('Error fetching data:', error);
  //   }
  // };
  // const fetchRecipientsData = async (fileId) => {
  //   const postData = {
  //     file_id: fileId,
  //   };
  //   try {
  //     const apiData = await post("file/getAllRecipientsByFileId", postData); // Specify the endpoint you want to call
  //     //console.log('Recipients');

  //     //console.log(apiData);
  //     if (apiData.error === true || apiData.error === "true") {
  //       setRecipientsData([]);
  //       setCountReceipient(apiData.result.length);
  //     } else {
  //       setRecipientsData(apiData.result);
  //       setCountReceipient(apiData.result.length);
  //     }
  //   } catch (error) {
  //     //console.log('Error fetching data:', error);
  //   }
  // };
  const fetchSignerData = async (fileId) => {
    const postData = {
      file_id: fileId,
    };
    try {
      const apiData = await post("file/getAllSignersByFileId", postData); // Specify the endpoint you want to call
      console.log("Signers ");

      console.log(apiData);
      if (apiData.error) {
        setSigners([]);
        setSelectedSigner([]);
        setActive("1");
        // setCount(0);
      } else {
        // if(apiData)
        setSigners(apiData.result);
        setSelectedSigner(apiData.result[apiData.result.length - 1]);

        // setSelectedSigner(apiData.result[0]);
        // setCount(apiData.result.length);
      }
    } catch (error) {
      //console.log('Error fetching data:', error);
    }
  };
  // const fetchDataPositions = async (fileId) => {
  //   // get positions from db
  //   const postData = {
  //     file_id: fileId,
  //   };
  //   const apiData = await post("file/getallPositionsFromFile_Id", postData); // Specify the endpoint you want to call
  //   console.log("Position Data");

  //   console.log(apiData);
  //   // if (apiData.error) {
  //   // } else {
  //   //   const positionsData = apiData.result[0]?.position_array;
  //   //console.log('positions');
  //   // console.log(apiData.result);
  //   // const annotationsForDatabase = {
  //   //   1: positionsData,
  //   // };
  //   // setAnnotations(annotationsForDatabase);
  //   if (!apiData.error && apiData.result?.[0]?.position_array) {
  //     const positionsData = apiData.result[0].position_array;

  //     // Parse the JSON string from database
  //     let parsedPositions;
  //     if (typeof positionsData === "string") {
  //       parsedPositions = JSON.parse(positionsData);
  //     } else {
  //       parsedPositions = positionsData;
  //     }

  //     // Group annotations by page number
  //     const groupedAnnotations = {};
  //     parsedPositions.forEach((annotation) => {
  //       const pageNo = annotation.page_no || 1; // Default to page 1 if not specified
  //       if (!groupedAnnotations[pageNo]) {
  //         groupedAnnotations[pageNo] = [];
  //       }
  //       groupedAnnotations[pageNo].push(annotation);
  //     });

  //     setAnnotations(groupedAnnotations);
  //   } else {
  //     setAnnotations({});
  //   }
  //   // }
  // };
  const seedAcroformAnnotations = async (fileId) => {
    try {
      const apiData = await post("bulk_links/getDetectedFormFields", {
        bulk_link_id: fileId,
      });
      const fields = apiData?.detected_form_fields || [];
      if (!Array.isArray(fields) || !fields.length) {
        console.log("=== PUBLIC SIGN ACROFORM: no detected_form_fields ===");
        setAnnotations({});
        return {};
      }
      const flat = acroformFieldsToAnnotations(fields, { mode: "forOthers" });
      const grouped = groupAnnotationsByPage(flat);
      console.log("=== PUBLIC SIGN ACROFORM: seeded annotations ===", flat.length);
      setAnnotations(grouped);
      return grouped;
    } catch (err) {
      console.error("Error seeding public-sign acroform annotations:", err);
      setAnnotations({});
      return {};
    }
  };

  const fetchDataPositions = async (fileId) => {
    try {
      const postData = {
        bulk_link_id: fileId,
      };

      const apiData = await post(
        "bulk_links/getallPositionsFromBulkLinkId",
        postData
      );
      console.log("Position Data");
      console.log(apiData);
      if (!apiData.error && apiData.result?.[0]?.position_array) {
        let positionsData = apiData.result[0].position_array;
        console.log("pos");

        // Parse if string
        if (typeof positionsData === "string") {
          positionsData = JSON.parse(positionsData);
        }

        if (!Array.isArray(positionsData)) {
          console.warn("Position data is not an array:", positionsData);
          return await seedAcroformAnnotations(fileId);
        }

        if (positionsData.length === 0) {
          return await seedAcroformAnnotations(fileId);
        }

        // Group by page number
        const groupedAnnotations = positionsData.reduce((acc, annotation) => {
          const pageNum = annotation.page_no || 1;
          if (!acc[pageNum]) {
            acc[pageNum] = [];
          }

          const resolvedFieldLabel = resolveFieldLabel(annotation);
          const rawText = annotation.text || "";
          const isTextType =
            annotation.type === "signer_text" || annotation.type === "my_text";

          // Keep text fields empty when only a generic placeholder exists,
          // so the configured field label can render in gray as intended.
          let defaultText =
            isTextType && isTextPlaceholderValue(rawText) ? "" : rawText;

          if (annotation.type === "signer_date" && (!annotation.text || annotation.text === "Date" || annotation.text === "Date..." || annotation.text === "Select a date")) {
            // Only pre-fill date if field is required; optional date fields stay empty
            if (annotation.isRequired) {
              defaultText = format(new Date(), annotation.dateFormat || "MMM dd, yyyy");
            } else {
              defaultText = "";
            }
          }

          if (isTextType) {
            console.log("[PUBLIC_FORM][LABEL]", {
              page: pageNum,
              annotationId: annotation.id,
              type: annotation.type,
              labelReceived: !!normalizeTextValue(resolvedFieldLabel),
              labelValue: normalizeTextValue(resolvedFieldLabel) || null,
              rawTextValue: normalizeTextValue(rawText) || null,
              normalizedTextValue: normalizeTextValue(defaultText) || null,
            });
          }

          // Ensure all required properties are present
          const formattedAnnotation = {
            id: annotation.id,
            type: annotation.type,
            x: annotation.x,
            y: annotation.y,
            width: annotation.width || 150,
            height: annotation.height || 30,
            text: defaultText,
            options: annotation.options || [],
            checked: annotation.checked || false,
            imageUrl: annotation.imageUrl || null,
            format: annotation.format || [],
            fontSize: annotation.fontSize || 14,
            fontFamily: annotation.fontFamily || "Helvetica",
            backgroundColor: annotation.backgroundColor || null,
            borderColor: annotation.borderColor || null,
            signerId: annotation.signerId || null,
            signerColor: annotation.signerColor || null,
            isRequired: annotation.isRequired || false,
            fieldLabel: resolvedFieldLabel,
            page_no: pageNum,
            source: annotation.source || null,
            acroform_name: annotation.acroform_name || null,
            preserveBox: annotation.preserveBox || false,
            ...(annotation.dateFormat && { dateFormat: annotation.dateFormat }),
          };

          acc[pageNum].push(formattedAnnotation);
          return acc;
        }, {});

        setAnnotations(groupedAnnotations);
        return groupedAnnotations;
      }

      return await seedAcroformAnnotations(fileId);
    } catch (error) {
      console.error("Error fetching positions:", error);
      return {};
    }
  };
  const [signer_currentObject, setSigner_currentObject] = useState(null);

  const [user_idSender, setUser_idSender] = useState(null);
  const [userEmailSender, setUserEmailSender] = useState(null);
  const [senderCompanyName, setSenderCompanyName] = useState("");
  const getUnhashedEmailFileId = async () => {
    //console.log('emailHashed', emailHashed);
    //console.log('fileId', fileId);
    const location = await getUserLocation();
    console.log("fileId", file_id);
    console.log("emailHashed", emailData);
    console.log("senderId", signerId);

    const postData = {
      bulk_link_id: file_id,

      // email: emailHashed,
      // file_id: file_id,
      // sender_user_id: senderId,
      // token: token,
      // location_country: location?.country,
      // ip_address: location?.ip,
      // location_date: location?.date,
      // region: location?.region,
      // timezone: location?.timezone,
    };
    try {
      // Multi-region (Phase 2c): resolve bulk link home region before API calls
      try {
        const resolveRes = await fetch(`${getRegion(DEFAULT_REGION).api.replace(/\/?$/, "/")}bulk_links/resolve-region/${file_id}`);
        const resolveJson = await resolveRes.json();
        const code = resolveJson?.region_code || DEFAULT_REGION;
        setActiveRegion(code);
        refreshRegionExports();
      } catch (_e) {
        setActiveRegion(DEFAULT_REGION);
        refreshRegionExports();
      }
      const apiData = await post("bulk_links/viewBulkLink", postData); // Specify the endpoint you want to call
      console.log("Update File Controls ");
      console.log(apiData);
      if (apiData.error === true) {
        setErrorModal(true);
        setIsLoading(false);
      } else {
        setDocumentId(file_id);
        // setSigner_currentObject(apiData?.signer_current);
        setWelcomeMessage(apiData.result.welcome_message);
        setAcknowledgmentMessage(apiData.result.acknowledgement_message);
        setUser_idSender(apiData?.result?.user_id);
        // setUserEmailSender(apiData?.user_sender?.email);
        // setSelectedSigner(apiData?.signer_current);
        setUniqIdDoc(apiData?.result?.uniq_id);
        setFileName(apiData?.result?.file_name);
        // setUserId()
        //console.log('You can sign');
        const pdfUrl = apiData?.result?.file_url;

        setOriginalPdf(pdfUrl);
        loadPdfFromUrl(pdfUrl);
        if (apiData?.company_logo === null) {
          setCompLogo(logoRemoveBg);
        } else {
          setCompLogo(apiData?.company_logo);
        }
        if (apiData?.primary_color === null) {
          setCompPrimaryColor("#23b3e8");
        } else {
          setCompPrimaryColor(apiData?.primary_color);
        }
        setSenderCompanyName(apiData?.company_name || "");
        // setImageUrlsCount(apiData?.bgImages[0]?.original_doc_pages);
        setImageUrls2(apiData?.result?.file_url);

        let isExpired = false;
        let responseLimitReached = false;
        let needsVerification = false;
        let canOpen = false;

        // ✅ Check if responses are limited
        if (apiData.result.limit_responses === "Limited") {
          const received_responses = parseInt(apiData.responses_received);
          const limit_responses = parseInt(apiData.result.link_response_limit);

          if (received_responses >= limit_responses) {
            responseLimitReached = true;
          }
        }

        // ✅ Check if link is expired (after end of expiry calendar day)
        if (
          apiData.result.expires_option === true ||
          apiData.result.expires_option === "true"
        ) {
          const expiryDate = new Date(apiData.result.expiry_date);
          if (!Number.isNaN(expiryDate.getTime())) {
            const endOfExpiryDay = new Date(
              expiryDate.getFullYear(),
              expiryDate.getMonth(),
              expiryDate.getDate(),
              23,
              59,
              59,
              999
            );
            if (new Date() > endOfExpiryDay) {
              isExpired = true;
            }
          }
        }

        // ✅ Check if email verification is needed
        if (
          apiData.result.user_email_verification === "true" ||
          apiData.result.user_email_verification === true
        ) {
          needsVerification = true;
          canOpen = true;
        }

        // ✅ Final Decision for `setOpen(true)` - Only if it's NOT expired & response limit not reached
        if (!isExpired && !responseLimitReached) {
          canOpen = true;
        }

        // ✅ Apply States
        setResponseLimitCompleted(responseLimitReached);
        setExpiredLink(isExpired);
        setVerificationNeeded(needsVerification);
        setOpen(canOpen);
        setLoaderData(false);

        // ✅ Debugging Console Logs
        console.log({
          responseLimitReached,
          isExpired,
          needsVerification,
          canOpen,
        });
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  // Modify your useEffect to include the loader
  useEffect(() => {
    setIsLoading(true);

    getUnhashedEmailFileId();
    fetchDataPositions(file_id);
  }, []);

  const [originalPdf, setOriginalPdf] = useState("");
  const [imageUrlsCount, setImageUrlsCount] = useState("");

  const [imageUrls2, setImageUrls2] = useState("");
  const [accessCodeModal, setAccessCodeModal] = useState(false);
  const [accessCodeSigner, setAccessCodeSigner] = useState("");
  const [signerLoginId, setSignerLoginId] = useState("1");
  const [currentSignerEmail, setCurrentSignerEmail] = useState("");
  const [currentSignerName, setCurrentSignerName] = useState("");

  const [activeAnnotation, setActiveAnnotation] = useState(null);

  // Update the initial image dimensions calculation
  const getInitialImageDimensions = (event, pageElement) => {
    const rect = pageElement.getBoundingClientRect();
    const defaultWidth = 200; // Default width in pixels
    // const defaultHeight = 150; // Default height in pixels
    // Create image to get natural dimensions
    const img = new Image();
    img.src =
      "https://res.cloudinary.com/dlm56y4v4/image/upload/v1739505479/loneliness/user_profiles/xy9byljg88e5rxtfuzc5.jpg";

    // Calculate aspect ratio based dimensions
    const aspectRatio = img.width / img.height;
    const defaultHeight = defaultWidth / aspectRatio;
    return {
      width: defaultWidth / scale,
      height: defaultHeight / scale,
      x: (event.clientX - rect.left) / scale,
      y: (event.clientY - rect.top) / scale,
    };
  };
  // Add this function to get default dimensions for different types
  const getDefaultDimensions = (type, scale) => {
    switch (type) {
      case "signer_initials":
        return {
          width: 250 / scale,
          height: 100 / scale,
        };
      case "my_signature":
        return {
          width: 250 / scale,
          height: 100 / scale,
        };
      case "signer_initials_text":
        return {
          width: 100 / scale,
          height: 100 / scale,
        };
      case "my_initials":
        return {
          width: 100 / scale,
          height: 100 / scale,
        };
      case "signer_chooseImgStamp":
        return {
          width: 150 / scale,
          height: 150 / scale, // Square for stamps
        };
      case "signer_chooseImgDrivingL":
        return {
          width: 350 / scale,
          height: 160 / scale, // Aspect ratio close to typical license
        };
      case "signer_chooseImgPassportPhoto":
        return {
          width: 250 / scale,
          height: 250 / scale, // Standard passport photo ratio
        };
      default:
        return {
          width: 150 / scale,
          height: 60 / scale,
        };
    }
  };
  const truncateName = (name, maxLength = 5) => {
    return name.length > maxLength
      ? `${name.substring(0, maxLength)}...`
      : name;
  };

  // Add this effect to measure first page height
  useEffect(() => {
    if (pdfImages.length > 0) {
      const img = new Image();
      img.onload = () => {
        setFirstPageHeight(img.height);
      };
      img.src = pdfImages[0];
    }
  }, [pdfImages]);
  // Add this useEffect to automatically select the last added signer
  useEffect(() => {
    if (signers?.length > 0) {
      setSelectedSignerId(signers[signers.length - 1]);
      setSelectedSigner(signers[signers.length - 1]);
      setActive("2");
    }
  }, [signers]);
  const [isInteracting, setIsInteracting] = useState(false);

  // Crop white space from signature/initial images (same as EsignReceivingEnd)
  const cropWhiteSpace = (base64Image) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        let minX = canvas.width;
        let minY = canvas.height;
        let maxX = 0;
        let maxY = 0;
        const whiteThreshold = 250;

        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            const idx = (y * canvas.width + x) * 4;
            const r = data[idx];
            const g = data[idx + 1];
            const b = data[idx + 2];
            const a = data[idx + 3];

            if (a > 0 && (r < whiteThreshold || g < whiteThreshold || b < whiteThreshold)) {
              minX = Math.min(minX, x);
              minY = Math.min(minY, y);
              maxX = Math.max(maxX, x);
              maxY = Math.max(maxY, y);
            }
          }
        }

        const padding = 5;
        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(canvas.width, maxX + padding);
        maxY = Math.min(canvas.height, maxY + padding);

        if (minX >= maxX || minY >= maxY) {
          resolve(base64Image);
          return;
        }

        const croppedCanvas = document.createElement("canvas");
        const croppedCtx = croppedCanvas.getContext("2d");
        const width = maxX - minX;
        const height = maxY - minY;

        croppedCanvas.width = width;
        croppedCanvas.height = height;

        croppedCtx.drawImage(
          img,
          minX, minY, width, height,
          0, 0, width, height
        );

        const croppedBase64 = croppedCanvas.toDataURL("image/png");
        resolve(croppedBase64);
      };

      img.onerror = () => {
        reject(new Error("Failed to load image"));
      };

      img.src = base64Image;
    });
  };

  const handleSignatureComplete = async (signatureData, typeData) => {
    if (!editingAnnotation) return;

    const { pageNum, index } = editingAnnotation;

    try {
      // Crop white space from signature/initial image (same as EsignReceivingEnd)
      const croppedSignatureData = await cropWhiteSpace(signatureData);

      const base64Response = await fetch(croppedSignatureData);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "signature.png", { type: "image/png" });

      // Upload to API
      const postData = {
        image: fileObject,
        user_id: user_idSender,
      };

      const apiData = await postFormData(postData);
      if (!apiData.public_url) {
        toastAlert("error", "Error uploading Files");
        return;
      }

      const imageUrl = apiData.public_url;

      setAnnotations((prev) => {
        const updatedAnnotations = { ...prev };
        updatedAnnotations[pageNum][index] = {
          ...updatedAnnotations[pageNum][index],
          imageUrl,
        };
        return updatedAnnotations;
      });

      setEditingAnnotation(null);
      setInitialBox(false);
      setLastClickPosition(null);
      setSignatureModalOpen(false);
    } catch (err) {
      console.error(err);
      toastAlert("error", "Error uploading signature");
    }
  };

  const shouldLockAspectRatio = (type) => {
    const typesWithLockedAspectRatio = [
      "stamp",
      "highlight",
      "my_signature",
      "my_initials",
      "signer_initials",
      "signer_initials_text",
      "signer_chooseImgStamp",
      "signer_chooseImgDrivingL",
      "signer_chooseImgPassportPhoto",
    ];
    return typesWithLockedAspectRatio.includes(type);
  };
  // 1. Add a new state for tracking the annotation being edited
  const [editingAnnotation, setEditingAnnotation] = useState(null);

  // 2. Add handler for editing signature
  const handleEditSignature = (pageNum, index, annot) => {
    setEditingAnnotation({ pageNum, index, annot });
    setInitialBox(annot.type === "my_initials");
    setSignatureModalOpen(true);
  };

  // 3. Add handler for editing stamp
  const handleEditStamp = (pageNum, index, annot) => {
    setEditingAnnotation({ pageNum, index, annot });
    stampInputRef.current.click();
  };
  const [lastClickPosition, setLastClickPosition] = useState(null);

  // Check if the current annotationType is in the array

  // Inside App.js, modify the handlePdfClick function

  const handleAnnotationClick = (pageNum, index, annotation) => {
    console.log("clicked texct ");
    console.log("clicked texct ", annotation);

    const annotationId = `${pageNum}-${index}`;
    setActiveAnnotationId(annotationId);
    setActiveAnnotation(annotationId);
    setSelectedAnnotation({
      ...annotation,
      pageNum,
      index,
    });
    // Set focused annotation
    setFocusedAnnotation(annotationId);
  };

  const handleAnnotationTextChange = (e, pageNum, index) => {
    const newText = e.target.value;
    const inputEl = annotationRefs.current[`${pageNum}-${index}`];

    if (!inputEl) return;

    // Create temporary span to measure text width
    const span = document.createElement("span");
    const computedStyle = window.getComputedStyle(inputEl);

    span.style.cssText = `
      visibility: hidden;
      position: fixed;
      font-family: ${computedStyle.fontFamily};
      font-size: ${computedStyle.fontSize};
      font-weight: ${computedStyle.fontWeight};
      font-style: ${computedStyle.fontStyle};
      letter-spacing: ${computedStyle.letterSpacing};
      white-space: pre;
      padding: ${computedStyle.padding};
    `;
    span.innerText = newText;
    document.body.appendChild(span);

    // Get available width (container width - padding)
    const padding = 8; // Total horizontal padding
    const containerWidth = inputEl.offsetWidth - padding;
    const textWidth = span.getBoundingClientRect().width;

    document.body.removeChild(span);

    // Only update text if it fits within the container
    if (textWidth <= containerWidth) {
      setAnnotations((prev) => {
        const pageAnns = [...(prev[pageNum] || [])];
        pageAnns[index] = {
          ...pageAnns[index],
          text: newText,
        };
        return { ...prev, [pageNum]: pageAnns };
      });
    }
  };
  const [isDeleting, setIsDeleting] = useState(false);
  // Handler to delete an annotation
  const handleDeleteAnnotation = (pageNum, index) => {
    setIsDeleting(true);
    const annotationElement = document.querySelector(
      `[data-annot-id="${pageNum}-${annotations[pageNum][index].id}"]`
    );
    if (annotationElement) {
      annotationElement.style.transition = "none";
    }

    setAnnotations((prev) => ({
      ...prev,
      [pageNum]: Array.isArray(prev[pageNum]) ? prev[pageNum].filter((_, i) => i !== index) : [],
    }));
    // setAnnotations((prev) => ({
    //   ...prev,
    //   [pageNum]: prev[pageNum].filter((_, i) => i !== index),
    // }));
  };

  // Memoize render image function
  const renderImage = useCallback((image, index, isMainView = true) => {
    return (
      <img
        src={image}
        alt={`Page ${index + 1}`}
        className={isMainView ? "pdf-image" : "thumbnail-image"}
        loading="lazy"
      />
    );
  }, []);

  const calculateTextWidth = useCallback((
    text,
    fontSize = 16,
    fontFamily = "Helvetica, Arial, sans-serif"
  ) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.font = `${fontSize}px ${fontFamily}`;
    const textWidth = Math.ceil(ctx.measureText(text).width);
    const padding = 10;
    return textWidth + padding;
  }, []);

  const calculateDateWidth = useCallback((dateText, fontSize, fontFamily, pageWidth, isMobileParam = false) => {
    if (!dateText || dateText === "Date" || dateText === "Date..." || dateText === "Select a date") {
      dateText = "MMM dd, yyyy";
    }
    const span = document.createElement("span");
    span.style.cssText = `
      visibility: hidden;
      position: fixed;
      font-family: ${fontFamily || "Helvetica, Arial, sans-serif"};
      font-size: ${fontSize || 15}px;
      font-weight: normal;
      font-style: normal;
      letter-spacing: 0;
      white-space: pre;
      padding: 3px 6px;
    `;
    span.innerText = dateText;
    document.body.appendChild(span);
    const textWidthPx = Math.ceil(span.getBoundingClientRect().width);
    document.body.removeChild(span);
    const bufferPx = isMobileParam ? 8 : 12;
    const totalWidthPx = textWidthPx + bufferPx;
    const widthPercent = (totalWidthPx / pageWidth) * 100;
    return widthPercent;
  }, []);

  const renderAnnotations = useCallback(
    (pageNum) => {
      const pageAnnotations = annotations[pageNum] || [];

      const imageElem = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!imageElem) return null; // Safe check if page not rendered yet

      // Use current dimensions so orientation change (portrait ↔ landscape) does not disturb positioning
      let pageWidth = imageElem.offsetWidth;
      let pageHeight = imageElem.offsetHeight;
      if (!pageWidth || !pageHeight) {
        const rect = imageElem.getBoundingClientRect();
        if (rect?.width > 0 && rect?.height > 0) {
          pageWidth = rect.width;
          pageHeight = rect.height;
        }
      }
      if (!pageWidth || !pageHeight) {
        console.warn(`Invalid image dimensions for page ${pageNum}`);
        return null;
      }
      return pageAnnotations.map((annot, index) => {
        if (!annot || typeof annot !== "object") {
          console.warn(
            `Invalid annotation at page ${pageNum}, index ${index}:`,
            annot
          );
          return null;
        }
        const pixelX = (annot.x / 100) * pageWidth;
        let pixelY = (annot.y / 100) * pageHeight;

        let pixelWidth;
        if (annot.type === "signer_date" || annot.type === "date") {
          const storedWidthPx = (typeof annot.width === "number" && annot.width > 0 ? annot.width / 100 : 0.15) * pageWidth;
          const mobileFontSize = Math.max(8, Math.min(10, annot.fontSize || 9));
          const minWidthPercent = calculateDateWidth(
            annot.text,
            isMobileOrTablet ? mobileFontSize : (annot.fontSize || 15),
            annot.fontFamily || "Helvetica, Arial, sans-serif",
            pageWidth,
            isMobileOrTablet
          );
          const minWidthPx = (minWidthPercent / 100) * pageWidth;
          if (isMobileOrTablet) {
            pixelWidth = minWidthPx;
          } else {
            pixelWidth = Math.max(storedWidthPx, minWidthPx);
          }
        } else {
          pixelWidth = (annot.width / 100) * pageWidth;
        }

        const heightPercent = typeof annot.height === "number" && annot.height > 0
          ? (annot.height <= 100 ? annot.height : (annot.height / pageHeight) * 100)
          : (30 / 400) * 100;
        const pixelHeight = (heightPercent / 100) * pageHeight;

        const isTextOrDateLike = annot.type === "signer_text" || annot.type === "signer_date" || annot.type === "date";
        const mobileFontPx = Math.max(8, Math.min(10, annot.fontSize || 9));
        const mobileTextHeight = isMobileOrTablet && isTextOrDateLike
          ? mobileFontPx + 6
          : null;

        const mobileCheckboxHeight = isMobileOrTablet && annot.type === "signer_checkmark"
          ? pixelHeight
          : null;

        let annotationHeight = pixelHeight;
        if (annot.type === "signer_date" || annot.type === "date") {
          const dateLayout = getDateFieldBoxLayout({
            pixelY,
            pixelHeight,
            fontSize: annot.fontSize || 15,
            isMobile: isMobileOrTablet,
            mobileTextHeight,
          });
          pixelY = dateLayout.top;
          annotationHeight = dateLayout.height;
        } else if (mobileTextHeight !== null) {
          annotationHeight = mobileTextHeight;
        } else if (mobileCheckboxHeight !== null) {
          annotationHeight = mobileCheckboxHeight;
        }

        return (
          <Rnd
            // scale={scale}
            id={`item-${annot.id}-${pageNum}`}
            key={`${pageNum}-${index}`}
            data-annot-id={`${pageNum}-${annot.id}`}
            default={{
              x: annot.x,
              y: annot.y,
            }}
            bounds="parent"
            dragGrid={[5, 5]}
            size={{ width: pixelWidth, height: annotationHeight }}
            position={{ x: pixelX, y: pixelY }}
            // size={{ width: annot.width, height: annot.height }}
            // position={{ x: annot.x * scale, y: annot.y * scale }}
            onClick={(e) => {
              e.stopPropagation();
              if (shouldLockAspectRatio(annot.type)) {
                setActiveAnnotation(`${pageNum}-${index}`);
              }
            }}
            onMouseDown={(e) => {
              if (shouldLockAspectRatio(annot.type)) {
                setActiveAnnotation(`${pageNum}-${index}`);
              }
            }}
            disableDragging={true}
            enableResizing={false}
            cancel=".react-rnd-resizable-handle"
            enableUserSelectHack={false}
            style={{
              display:
                parseInt(signerLoginId) === parseInt(annot.signerId)
                  ? "block"
                  : "none",
              transition:
                isDragging || isResizing || isDeleting
                  ? "none"
                  : "transform 0.1s ease-out",
              cursor: "default",
              overflow: "hidden",
            }}
          >
            {/* {`item-${annot.id}-${pageNum}`} */}
            {/* {signerLoginId}=={annot.signerId} */}
            <Box
              className="annotation"
              data-type={annot.type}
              sx={{
                position: "relative",
                display: "flex",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                cursor:
                  annot.type === "my_text" || annot.type === "date"
                    ? "text"
                    : annot.type === "checkmark" ||
                      annot.type === "signer_checkmark"
                      ? "pointer"
                      : "default",
                alignItems: "flex-start",
                transition:
                  isDragging || isResizing || isDeleting
                    ? "none"
                    : "width 0.1s ease-out",
                padding: 0,
                margin: 0,
                border: "none",
                backgroundColor: "transparent",
                boxSizing: "border-box",
                "&:hover": {
                  "& .resize-handle": {
                    opacity: 1,
                  },
                },
              }}
            >
              {/* signer_date: display-only on both mobile and desktop; click opens date modal (same as EsignReceivingEnd) */}
              {(annot.type === "signer_date" || (annot.type === "signer_dropdown" && isMobileOrTablet)) ? (
                <ShrinkToFitText
                  text={annot.text ||
                    (annot.type === "signer_dropdown"
                      ? "Select an option"
                      : annot.type === "signer_date"
                        ? "Date"
                        : "enter text")}
                  onClick={() => handleAnnotClick(pageNum, index, annot.type)}
                  style={{
                    position: "relative",
                    alignItems: "flex-end",
                    justifyContent: "flex-start",
                    textAlign: "left",
                    padding: isMobileOrTablet ? "0px 3px 0px" : "0px 5px 0px",
                    margin: 0,
                    width: "100%",
                    height: "100%",
                    fontSize: isMobileOrTablet
                      ? `${Math.max(8, Math.min(10, annot.fontSize || 9))}px`
                      : `${Math.max(10, Math.min(72, annot.fontSize || 15))}px`,
                    fontFamily: annot.fontFamily || "Helvetica, Arial, sans-serif",
                    lineHeight: 1,
                    backgroundColor: annot.backgroundColor
                      ? colorWithAlpha(annot.backgroundColor, annot.isRequired ? 0.8 : 0.6)
                      : getColorWithCustomOpacity(
                        annot.signerColor || getSignerColorById(annot.signerId, signers),
                        annot.isRequired,
                        80,
                        60
                      ),
                    borderRadius: "4px",
                    border: "1px solid rgba(0, 51, 153, 0.3)",
                    cursor: "pointer",
                    fontWeight: annot.text ? 500 : 400,
                    boxSizing: "border-box",
                  }}
                />
              ) : null}
              {/* signer_text: display-only, click opens TextEntryDialog (same as EsignReceivingEnd) */}
              {annot?.type === "signer_text" ? (
                <ShrinkToFitText
                  text={annot.text?.trim()
                    ? annot.text
                    : (annot.fieldLabel?.trim() || "Enter text")}
                  title={
                    annot.text?.trim()
                      ? annot.text
                      : (annot.fieldLabel?.trim() || "Enter text")
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditText(pageNum, index, annot);
                  }}
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    fontSize: isMobileOrTablet
                      ? `${Math.max(8, Math.min(10, annot.fontSize || 9))}px`
                      : `${Math.max(10, Math.min(72, annot.fontSize || 15))}px`,
                    fontFamily: annot.fontFamily || "Helvetica, Arial, sans-serif",
                    fontWeight: annot.format?.includes("bold") ? "bold" : "normal",
                    fontStyle: annot.format?.includes("italic") ? "italic" : "normal",
                    textDecoration: annot.format?.includes("underline") ? "underline" : "none",
                    color: annot.text?.trim()
                      ? "rgba(0, 0, 0, 0.87)"
                      : "rgba(0, 0, 0, 0.45)",
                    backgroundColor: annot.backgroundColor
                      ? colorWithAlpha(annot.backgroundColor, annot.isRequired ? 0.8 : 0.6)
                      : getColorWithCustomOpacity(
                        getSignerColorById(annot.signerId, signers),
                        annot.isRequired,
                        80,
                        60
                      ),
                    padding: isMobileOrTablet ? "0px 3px 0px" : "0px 5px 0px",
                    borderRadius: "4px",
                    textAlign: annot.alignment || "left",
                    alignItems: "flex-end",
                    justifyContent: "flex-start",
                    lineHeight: 1,
                    boxSizing: "border-box",
                    border:
                      activeAnnotationId === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "1px solid rgba(0, 0, 0, 0.23)",
                    cursor: "pointer",
                  }}
                />
              ) : null}

              {/* my_text and date: display-only, click opens TextEntryDialog (same as EsignReceivingEnd) */}
              {(annot?.type === "my_text" || annot?.type === "date") ? (
                <ShrinkToFitText
                  text={annot.type === "date"
                    ? (annot.text || "Date")
                    : (annot.text?.trim() || annot.fieldLabel?.trim() || "Enter text")}
                  title={
                    annot.type === "my_text"
                      ? (annot.text?.trim() || annot.fieldLabel?.trim() || "Enter text")
                      : (annot.text || "Date")
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditText(pageNum, index, annot);
                  }}
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    fontSize: isMobileOrTablet
                      ? `${Math.max(8, Math.min(10, annot.fontSize || 9))}px`
                      : `${Math.max(10, Math.min(72, annot.fontSize || 15))}px`,
                    fontFamily: annot.fontFamily || "Helvetica, Arial, sans-serif",
                    fontWeight: annot.format?.includes("bold") ? "bold" : "normal",
                    fontStyle: annot.format?.includes("italic") ? "italic" : "normal",
                    textDecoration: annot.format?.includes("underline") ? "underline" : "none",
                    color:
                      annot.type === "my_text" && !annot.text?.trim()
                        ? "rgba(0, 0, 0, 0.45)"
                        : (annot.color || "rgba(0, 0, 0, 0.87)"),
                    backgroundColor: annot.backgroundColor
                      ? colorWithAlpha(annot.backgroundColor, annot.isRequired ? 0.8 : 0.6)
                      : (annot.signerId
                        ? getColorWithCustomOpacity(
                          getSignerColorById(annot.signerId, signers),
                          annot.isRequired,
                          80,
                          60
                        )
                        : undefined),
                    padding: isMobileOrTablet ? "0px 3px 0px" : "0px 5px 0px",
                    lineHeight: 1,
                    alignItems: "flex-end",
                    justifyContent: "flex-start",
                    textAlign: annot.alignment || "left",
                    cursor: "pointer",
                  }}
                />
              ) : null}

              {annot?.type === "signer_checkmark" && (
                <Box
                  sx={{
                    width: pixelWidth,
                    height: pixelHeight,
                    maxHeight: pixelHeight,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "visible",
                    backgroundColor: annot.backgroundColor
                      ? colorWithAlpha(annot.backgroundColor, 0.6)
                      : getColorWithCustomOpacity(annot.signerColor, false, 80, 60),
                    border:
                      activeAnnotationId === `${pageNum}-${index}`
                        ? "2px solid rgb(0, 145, 255)"
                        : "1px solid rgba(0, 0, 0, 0.23)",
                    borderRadius: "4px",
                    cursor: "pointer",
                    "&:hover": {
                      border: "2px solid rgb(0, 145, 255)",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnnotations((prev) => {
                      const pageAnnotations = [...(prev[pageNum] || [])];
                      pageAnnotations[index] = {
                        ...pageAnnotations[index],
                        checked: !pageAnnotations[index].checked,
                      };
                      return {
                        ...prev,
                        [pageNum]: pageAnnotations,
                      };
                    });
                    setActiveAnnotationId(`${pageNum}-${index}`);
                  }}
                >
                  {annot.checked ? (
                    <CheckBoxIcon
                      sx={{
                        width: isMobileOrTablet ? 15 : "100%",
                        height: isMobileOrTablet ? 15 : "100%",
                        color: "rgb(0, 145, 255)",
                      }}
                    />
                  ) : (
                    <CheckBoxOutlineBlankIcon
                      sx={{
                        width: isMobileOrTablet ? 15 : "100%",
                        height: isMobileOrTablet ? 15 : "100%",
                        color: "rgba(0, 0, 0, 0.54)",
                      }}
                    />
                  )}
                </Box>
              )}

              {[
                "signer_initials",
                "signer_initials_text",
                "signer_chooseImgStamp",
                "signer_chooseImgDrivingL",
                "signer_chooseImgPassportPhoto",
              ].includes(annot.type) && (
                  <>
                    {!annot.imageUrl ? (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          setFocusedAnnotation(`${pageNum}-${index}`);
                          handleAnnotationClick(pageNum, index, annot);

                          if (isSignatureType(annot.type)) {
                            // Open signature modal
                            setLastClickPosition({ x: annot.x, y: annot.y });
                            handleEditSignature(pageNum, index, annot);
                            setPageNoClicked(pageNum);
                            setInitialBox(annot.type === "signer_initials_text");
                            // setSignatureModalOpen(true);
                          } else if (isImageUploadType(annot.type)) {
                            // Open file picker for image types
                            const input = document.createElement("input");
                            input.type = "file";
                            input.accept = "image/*";
                            input.onchange = (event) => {
                              const file = event.target.files[0];
                              if (file) {
                                console.log(file);
                                const reader = new FileReader();
                                reader.onload = (e) => {
                                  setCropSrc(e.target.result);
                                  setPendingStampAction({
                                    isEdit: true,
                                    editData: { pageNum, index, annot },
                                  });
                                  setCropperModalOpen(true);
                                };
                                reader.readAsDataURL(file);
                              }
                            };
                            input.click();
                          }
                        }}
                        sx={{
                          width: pixelWidth,
                          height: pixelHeight,
                          position: "relative",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: annot.backgroundColor
                            ? colorWithAlpha(annot.backgroundColor, annot.isRequired ? 0.8 : 0.6)
                            : getColorWithCustomOpacity(annot.signerColor, annot.isRequired, 80, 60),
                          border:
                            activeAnnotationId === `${pageNum}-${index}`
                              ? "2px solid rgb(0, 145, 255)"
                              : "1px solid rgba(0, 145, 255, 0.3)",
                          borderRadius: "4px",
                          gap: 0.5,
                          transition: "all 0.2s ease-out",
                          "&:hover": {
                            backgroundColor: `${selectedSigner?.color}30`,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: 1,
                          }}
                        >
                          {getSignerBoxContent(annot.type)?.icon}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "rgba(0, 0, 0, 0.87)",
                            fontSize: isMobileOrTablet ? `${Math.max(8, Math.min(10, annot.fontSize || 9))}px` : `21px`,
                            // fontSize: "21px",
                            textAlign: "center",
                          }}
                        >
                          {getSignerBoxContent(annot.type)?.text}
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        onClick={(e) => {
                          e.stopPropagation();
                          setFocusedAnnotation(`${pageNum}-${index}`);
                          handleAnnotationClick(pageNum, index, annot);
                        }}
                        sx={{
                          width: pixelWidth,
                          height: pixelHeight,
                          position: "relative",
                          cursor: "pointer",
                          display: "flex",
                          // Center signature/initial images in the annotation box
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: annot.backgroundColor
                            ? colorWithAlpha(annot.backgroundColor, annot.isRequired ? 0.8 : 0.6)
                            : getColorWithCustomOpacity(annot.signerColor, annot.isRequired, 80, 60),
                          border:
                            activeAnnotationId === `${pageNum}-${index}`
                              ? "2px solid rgb(0, 145, 255)"
                              : "1px solid rgba(0, 145, 255, 0.3)",
                          borderRadius: "4px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={annot.imageUrl}
                          alt="Uploaded content"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            width: "auto",
                            height: "auto",
                            objectFit: "contain",
                            objectPosition: "center center",
                          }}
                        />
                      </Box>
                    )}{" "}
                  </>
                )}
              {annot.type === "signer_dropdown" && !isMobileOrTablet && (
                <TextField
                  select
                  fullWidth
                  variant="outlined"
                  value={annot.selectedOption || ""} // Controlled value from annotation
                  onChange={(e) => {
                    const newOption = e.target.value;
                    setAnnotations((prev) => ({
                      ...prev,
                      [pageNum]: prev[pageNum].map((a, i) =>
                        i === index ? { ...a, selectedOption: newOption } : a
                      ),
                    }));
                  }}
                  placeholder="Select..."
                  onClick={(e) => {
                    e.stopPropagation();
                    setFocusedAnnotation(`${pageNum}-${index}`);
                    handleAnnotationClick(pageNum, index, annot);
                  }}
                  onBlur={() => {
                    setFocusedAnnotation(null);
                  }}
                  onMouseEnter={() => {
                    document.body.style.cursor = "default";
                    if (cursorRef.current) {
                      cursorRef.current.style.display = "none";
                    }
                  }}
                  onMouseLeave={() => {
                    if (isAnnotating && !focusedAnnotation) {
                      document.body.style.cursor = "none";
                      if (cursorRef.current) {
                        cursorRef.current.style.display = "block";
                      }
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: getColorWithCustomOpacity(
                        getSignerColorById(annot.signerId, signers),
                        annot.isRequired,
                        80,
                        60
                      ),
                      width: pixelWidth,
                      height: pixelHeight,
                      cursor: "pointer !important", // Should be pointer since user can select
                      "& .MuiSelect-select": {
                        cursor: "pointer !important",
                      },
                      "& .MuiOutlinedInput-input": {
                        cursor: "pointer !important",
                      },
                      border:
                        activeAnnotationId === `${pageNum}-${index}`
                          ? "2px solid rgb(0, 145, 255)"
                          : "1px solid rgba(0, 0, 0, 0.23)",
                      "&:hover": {
                        border: `2px solid ${annot.borderColor || "rgb(0, 145, 255)"
                          }`,
                        cursor: "pointer !important",
                      },
                      "& *": {
                        cursor: "pointer !important",
                      },
                    },
                  }}
                >
                  {annot.options && annot.options.length > 0 ? (
                    annot.options.map((option, idx) => (
                      <MenuItem key={idx} value={option}>
                        {option}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No options</MenuItem>
                  )}
                </TextField>
              )}

              {(annot.type === "signer_initials" ||
                annot.type === "signer_chooseImgStamp" ||
                annot.type === "signer_chooseImgDrivingL" ||
                annot.type === "signer_chooseImgPassportPhoto" ||
                annot.type === "signer_initials_text") &&
                annot.imageUrl ? (
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    top: "-15px",
                    right: "5px",
                    backgroundColor: "rgb(35, 179, 232)",
                    padding: "3px",
                    zIndex: 1000,
                    cursor: "pointer !important",
                    "&:hover": {
                      backgroundColor: "rgb(2 142 193)", // Darker red on hover
                      cursor: "pointer !important",
                    },
                  }}
                  disableRipple
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      annot.type === "signer_initials" ||
                      annot.type === "signer_initials_text"
                    ) {
                      handleEditSignature(pageNum, index, annot);
                    } else if (
                      annot.type === "signer_chooseImgStamp" ||
                      annot.type === "signer_chooseImgPassportPhoto" ||
                      annot.type === "signer_chooseImgDrivingL"
                    ) {
                      handleEditStamp(pageNum, index, annot);
                    }
                  }}
                  onMouseDown={(e) => e.stopPropagation()} // Prevent drag events
                  onMouseUp={(e) => e.stopPropagation()}
                >
                  <EditIcon
                    sx={{
                      color: "white",
                      fontSize: "15px",
                      pointerEvents: "none",
                    }}
                  />
                </IconButton>
              ) : null}
            </Box>
          </Rnd>
        );
      });
    },
    [annotations, isAnnotating, focusedAnnotation, scale, isInteracting, isMobileOrTablet, isMobilePortrait, calculateDateWidth, calculateTextWidth, signerLoginId, signers]
  );

  const mainContainerClass = isAnnotating ? "custom-cursor" : "";
  // Update the useEffect for cursor handling

  useEffect(() => {
    if (isAnnotating) {
      const cursorElement = document.createElement("div");
      cursorElement.classList.add("custom-cursor-image");
      document.body.appendChild(cursorElement);
      cursorRef.current = cursorElement;

      const moveCursor = (e) => {
        const target = e.target;
        const isTextField =
          target.tagName === "INPUT" || target.closest(".MuiTextField-root");
        const isImageAnnotation =
          target.closest(".annotation") &&
          target.closest(".annotation").querySelector("img");
        const isResizeHandle = target.closest(".react-rnd-resizable-handle");
        const isPdfContainer = target.closest(".pdf-container");
        const isSidebar =
          target.closest(".left-sidebar") ||
          target.closest(".right-sidebar") ||
          target.closest(".zoom-container");
        // Add checks for edit and delete icons
        const isEditIcon =
          target.closest('[aria-label="edit"]') ||
          target.closest(".MuiIconButton-root");
        const isDeleteIcon = target.closest('[aria-label="close"]');
        const isActionIcon = isEditIcon || isDeleteIcon;

        // Hide custom cursor and show pointer for action icons
        if (isActionIcon) {
          cursorRef.current.style.display = "none";
          document.body.style.cursor = "pointer";
          return;
        }

        // Rest of your existing cursor logic
        if (isImageAnnotation) {
          cursorRef.current.style.display = "block";
          cursorRef.current.style.left = `${e.clientX}px`;
          cursorRef.current.style.top = `${e.clientY}px`;
          document.body.style.cursor = "none";
          return;
        }

        if (isResizeHandle || isSidebar) {
          cursorRef.current.style.display = "none";
          document.body.style.cursor = "default";
          return;
        }

        if (isPdfContainer && !isTextField) {
          cursorRef.current.style.display = "block";
          cursorRef.current.style.left = `${e.clientX}px`;
          cursorRef.current.style.top = `${e.clientY}px`;
          document.body.style.cursor = "none";
        } else {
          cursorRef.current.style.display = "none";
          document.body.style.cursor = isTextField ? "text" : "default";
        }
      };

      document.addEventListener("mousemove", moveCursor);
      return () => {
        document.removeEventListener("mousemove", moveCursor);
        if (cursorRef.current?.parentNode) {
          document.body.removeChild(cursorRef.current);
          cursorRef.current = null;
        }
        document.body.style.cursor = "default";
      };
    }
  }, [isAnnotating]);
  // Initialize zoom state for mobile view
  useEffect(() => {
    if (isMobileOrTablet) {
      setIsZoomed(scale > 1.1);
    }
  }, [scale]);
  // In your App component
  const [isDownloading, setIsDownloading] = useState(false);
  // const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadOriginal = async () => {
    if (!originalPdf) return;

    setIsDownloading(true);
    try {
      const supportedTypes = [
        "my_text",
        "signer_text",
        "date",
        "signer_date",
        "my_signature",
        "my_initials",
        "signer_initials",
        "signer_initials_text",
        "checkmark",
        "signer_checkmark",
        "stamp",
        "highlight",
        "signer_chooseImgStamp",
        "signer_chooseImgDrivingL",
        "signer_chooseImgPassportPhoto",
        "signer_dropdown",
        "my_dropdown",
      ];
      const filteredAnnotations = {};
      Object.entries(annotations || {}).forEach(([pageNum, pageAnnotations]) => {
        if (!Array.isArray(pageAnnotations)) return;
        const list = pageAnnotations.filter((annot) => {
          if (!supportedTypes.includes(annot.type)) return false;
          if (parseInt(signerLoginId) !== parseInt(annot.signerId)) return false;
          return true;
        });
        if (list.length > 0) filteredAnnotations[pageNum] = list;
      });

      if (Object.keys(filteredAnnotations).length > 0) {
        let editorPageWidthPx;
        const firstPageKey = Object.keys(filteredAnnotations)[0];
        if (firstPageKey) {
          const pageEl = document.querySelector(`#img-${firstPageKey} .pdf-image`);
          if (pageEl) {
            const rect = pageEl.getBoundingClientRect();
            if (rect?.width > 0) editorPageWidthPx = rect.width;
          }
        }
        const success = await downloadPdfWithTextAnnotations(
          originalPdf,
          filteredAnnotations,
          fileName || "document.pdf",
          {
            editorPageWidthPx: editorPageWidthPx ?? undefined,
            logFontScale: true,
            // Small download-only bottom padding so text doesn't touch the line.
            textVerticalNudgeUpPoints: 2,
            disableMobileTextScale: true,
          }
        );
        if (!success) toastAlert("error", "Failed to download PDF with annotations");
      } else {
        const success = await downloadOriginalPdf(originalPdf, fileName);
        if (!success) toastAlert("error", "Failed to download PDF");
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toastAlert("error", "Failed to download PDF");
    } finally {
      setIsDownloading(false);
    }
  };
  useEffect(() => {
    if (modalOpen && annotationType === "signer_text") {
      // Delay to ensure ref is available
      setTimeout(() => {
        const inputEl = document.querySelector(".MuiDialogContent-root input");
        if (!inputEl) return;

        // Get the font styles
        const computedStyle = window.getComputedStyle(inputEl);

        // Create a hidden span to measure text width
        const span = document.createElement("span");
        span.style.cssText = `
            visibility: hidden;
            position: fixed;
            font-family: ${computedStyle.fontFamily};
            font-size: ${computedStyle.fontSize};
            font-weight: ${computedStyle.fontWeight};
            font-style: ${computedStyle.fontStyle};
            letter-spacing: ${computedStyle.letterSpacing};
            white-space: pre;
            padding: ${computedStyle.padding};
          `;

        document.body.appendChild(span);

        // Available width for text input
        const containerWidth = inputEl.offsetWidth - 8; // Account for padding
        let allowedChars = 0;

        // Incrementally add characters until it exceeds width
        for (let i = 1; i <= 100; i++) {
          span.innerText = "W".repeat(i); // Use a wide character
          if (span.getBoundingClientRect().width > containerWidth) break;
          allowedChars = i;
        }

        document.body.removeChild(span);
        setMaxChars(allowedChars);
      }, 100);
    }
  }, [modalOpen, annotationType]);

  useEffect(() => {
    if (isMobileOrTablet) {
      let viewport = document.querySelector('meta[name="viewport"]');

      // Create viewport meta tag if it doesn't exist
      if (!viewport) {
        viewport = document.createElement("meta");
        viewport.name = "viewport";
        document.head.appendChild(viewport);
      }

      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      // Add/remove Safari-specific CSS to disable auto-zoom
      const addSafariZoomDisableCSS = () => {
        let safariStyle = document.getElementById("safari-zoom-disable");
        if (!safariStyle) {
          safariStyle = document.createElement("style");
          safariStyle.id = "safari-zoom-disable";
          document.head.appendChild(safariStyle);
        }

        // CSS to disable Safari's automatic zoom on input focus
        safariStyle.textContent = `
           @supports (-webkit-touch-callout: none) {
             input, textarea, select {
               font-size: 16px !important;
               transform: scale(1) !important;
               zoom: 1 !important;
             }
             .MuiInputBase-input {
               font-size: 16px !important;
               transform: scale(1) !important;
               zoom: 1 !important;
             }
             .MuiTextField-root input {
               font-size: 16px !important;
               transform: scale(1) !important;
               zoom: 1 !important;
             }
             .MuiSelect-select {
               font-size: 16px !important;
               transform: scale(1) !important;
               zoom: 1 !important;
             }
             html, body {
               zoom: 1 !important;
               transform: scale(1) !important;
             }
           }
         `;
      };

      const removeSafariZoomDisableCSS = () => {
        const safariStyle = document.getElementById("safari-zoom-disable");
        if (safariStyle) {
          safariStyle.remove();
        }
      };

      // Function to force zoom reset on iOS/Safari
      const forceZoomReset = () => {
        if (isSafari || isIOS) {
          // Multiple approaches to reset zoom

          // Method 1: Reset viewport with forced refresh
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"
          );

          // Method 2: Force a layout recalculation
          document.body.style.zoom = "1";
          document.documentElement.style.zoom = "1";

          // Method 3: Use transform to reset scale
          document.body.style.transform = "scale(1)";
          document.documentElement.style.transform = "scale(1)";

          // Method 4: Scroll manipulation to reset zoom
          window.scrollTo(0, 0);

          // Method 5: Focus manipulation
          const activeElement = document.activeElement;
          if (activeElement && activeElement.blur) {
            activeElement.blur();
          }

          // Method 6: Force a slight delay then reapply viewport
          setTimeout(() => {
            viewport.setAttribute(
              "content",
              "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, shrink-to-fit=no, viewport-fit=cover"
            );
          }, 10);

          // Method 7: Trigger a resize event
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 50);
        }
      };

      if (modalOpen || cropperModalOpen || signatureModalOpen) {
        // For Safari, set viewport to completely disable zoom
        if (isSafari || isIOS) {
          // Add CSS to prevent auto-zoom
          addSafariZoomDisableCSS();

          // Force zoom reset first
          forceZoomReset();

          // Set aggressive viewport settings for Safari
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, shrink-to-fit=no, viewport-fit=cover"
          );

          // Additional Safari-specific DOM settings
          document.body.style.touchAction = "manipulation";
          document.documentElement.style.webkitUserSelect = "none";
          document.documentElement.style.webkitTouchCallout = "none";
          document.documentElement.style.webkitTapHighlightColor =
            "transparent";

          // Prevent text size adjustment
          document.body.style.webkitTextSizeAdjust = "100%";
          document.documentElement.style.webkitTextSizeAdjust = "100%";

          // Force fixed positioning context
          document.body.style.position = "relative";
          document.body.style.overflow = "hidden";

          // Additional zoom prevention
          document.body.style.zoom = "1";
          document.documentElement.style.zoom = "1";
          document.body.style.transform = "scale(1)";
          document.documentElement.style.transform = "scale(1)";
        } else {
          // Non-Safari browsers
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"
          );
        }

        // Blur any focused elements that might trigger zoom
        const activeElement = document.activeElement;
        if (activeElement && activeElement !== document.body) {
          activeElement.blur();
          document.body.focus();
        }

        // Scroll to top to reset any zoom
        window.scrollTo(0, 0);
      } else {
        // Restore default viewport when modals close
        if (isSafari || isIOS) {
          // Remove Safari-specific CSS
          removeSafariZoomDisableCSS();

          // Restore normal viewport
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1, viewport-fit=cover"
          );

          // Reset Safari-specific styles
          document.body.style.touchAction = "";
          document.documentElement.style.webkitUserSelect = "";
          document.documentElement.style.webkitTouchCallout = "";
          document.documentElement.style.webkitTapHighlightColor = "";
          document.body.style.webkitTextSizeAdjust = "";
          document.documentElement.style.webkitTextSizeAdjust = "";
          document.body.style.position = "";
          document.body.style.overflow = "";
          document.body.style.zoom = "";
          document.documentElement.style.zoom = "";
          document.body.style.transform = "";
          document.documentElement.style.transform = "";
        } else {
          // Non-Safari browsers
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1, viewport-fit=cover"
          );
        }
      }
    }
  }, [modalOpen, cropperModalOpen, signatureModalOpen]);
  // hashed ids

  useEffect(() => {
    const handleResize = debounce(() => {
      // Force re-render of annotations when screen size changes
      setAnnotations((prev) => ({ ...prev }));
      // setAnnotations((prev) => {
      //   const updated = { ...prev };
      //   // Add a timestamp to force re-render without changing data
      //   updated._lastUpdate = Date.now();
      //   return updated;
      // });
      // Force re-render by updating state properly
      // setAnnotations((prev) => {
      //   // Ensure we're working with valid annotation structure
      //   const validAnnotations = {};

      //   Object.keys(prev).forEach((pageNum) => {
      //     if (Array.isArray(prev[pageNum])) {
      //       validAnnotations[pageNum] = [...prev[pageNum]];
      //     } else if (pageNum !== "_lastUpdate") {
      //       // Reset invalid page annotations to empty array
      //       validAnnotations[pageNum] = [];
      //     }
      //   });

      //   // Add timestamp for re-render
      //   validAnnotations._lastUpdate = Date.now();

      //   return validAnnotations;
      // });
    }, 100);

    const handleZoom = debounce(() => {
      // Detect zoom changes and recalculate
      const currentZoom = window.devicePixelRatio;
      if (Math.abs(currentZoom - (window.lastZoom || 1)) > 0.1) {
        window.lastZoom = currentZoom;
        // setAnnotations((prev) => {
        //   const updated = { ...prev };
        //   updated._lastUpdate = Date.now();
        //   return updated;
        // });
        setAnnotations((prev) => ({ ...prev }));
      }
      // if (Math.abs(currentZoom - (window.lastZoom || 1)) > 0.1) {
      //   window.lastZoom = currentZoom;

      //   setAnnotations((prev) => {
      //     // Same validation as above
      //     const validAnnotations = {};

      //     Object.keys(prev).forEach((pageNum) => {
      //       if (Array.isArray(prev[pageNum])) {
      //         validAnnotations[pageNum] = [...prev[pageNum]];
      //       } else if (pageNum !== "_lastUpdate") {
      //         validAnnotations[pageNum] = [];
      //       }
      //     });

      //     validAnnotations._lastUpdate = Date.now();
      //     return validAnnotations;
      //   });
      // }
    }, 100);

    window.addEventListener("resize", handleResize);
    window.addEventListener("wheel", handleZoom, { passive: true });

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("wheel", handleZoom);
    };
  }, []);
  // Add this right after your state declarations, before any useEffects

  // Replace your existing resize effect with this improved version:

  // Add this function after your existing functions
  // Add this useEffect after your existing ones
  useEffect(() => {
    if (pdfImages.length > 0 && pdfContainerRef.current) {
      // Auto-fit PDF to container on initial load
      const timeoutId = setTimeout(() => {
        const container = pdfContainerRef.current;
        const firstPage = container?.querySelector(".pdf-page-container");

        if (firstPage && container) {
          const containerWidth = container.offsetWidth;
          const pageWidth = firstPage.scrollWidth;

          // If PDF is much smaller than container, increase scale slightly
          if (pageWidth < containerWidth * 0.7) {
            const newScale = Math.min(1.2, (containerWidth * 0.9) / pageWidth);
            setScale(newScale);
          }
        }
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [pdfImages]);

  // Add this enhanced scale effect
  useEffect(() => {
    const handleScaleChange = debounce(() => {
      // Detect if the PDF container size has changed significantly
      const container = pdfContainerRef.current;
      if (!container) return;

      const newContainerWidth = container.offsetWidth;
      const widthDifference = Math.abs(newContainerWidth - containerWidth);

      // Only trigger recalculation if change is significant (more than 50px)
      if (widthDifference > 50) {
        setContainerWidth(newContainerWidth);

        // Force annotation recalculation
        setTimeout(() => {
          setAnnotations((prev) => {
            const updated = { ...prev };
            updated._lastUpdate = Date.now();
            return updated;
          });
        }, 100); // Small delay to ensure PDF has rendered
      }
    }, 200);

    // Use ResizeObserver for more accurate container size tracking
    const resizeObserver = new ResizeObserver(handleScaleChange);

    if (pdfContainerRef.current) {
      resizeObserver.observe(pdfContainerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerWidth]);
  return (
    <>
      {isLoading && <FullScreenLoader />}

      <Box className={mainContainerClass}>
        {/* Add this near the end of your return statement, alongside other modals */}

        <input
          type="file"
          ref={stampInputRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleStampFileSelect} // Remove lastClickPosition parameter
        />
        <FileUpload
          logo={compLogo}
          primaryColorComp={compPrimaryColor}
          handleCompletedTrue={() => {
            setDocSignerStatusModal(true);
          }}
          imageUrlsCount={imageUrlsCount}
          imageUrls2={imageUrls2}
          all_recipientsData={all_recipientsData}
          fileUserid={fileUserid}
          signerLoginId={signerLoginId}
          currentSignerEmail={currentSignerEmail}
          currentSignerName={currentSignerName}
          signer_currentObject={signer_currentObject}
          emailSubject={emailSubject}
          setEmailSubject={setEmailSubject}
          emailMessage={emailMessage}
          setEmailMessage={setEmailMessage}
          originalPdf={originalPdf}
          uniqIdDoc={uniqIdDoc}
          user_email={user_email}
          completed={() => {
            setDocSignerStatusModal(true);
          }}
          templateReceiver={false}
          publicFormReceiver={true}
          file_id={documentId}
          annotations={annotations}
          signers={signers}
          setSigners={setSigners}
          user_id={user_idSender}
          file_name={fileName || "Document"}
          // pdfUrl="https://y5f8.c1.e2-7.dev/requiresign-testing-bucket/112316_riazirim22%2F20241106%2F0019_Invoice-2C6D4BDF-0024.pdf" // Add your PDF URL here
          onDownloadOriginal={handleDownloadOriginal}
          isDownloading={isDownloading}
        />
        {/* <Button
          onClick={() => {
            shareDocument();
          }}
          variant="contained"
          component="span"
          sx={{
            textTransform: "none",
            color: "white",
            marginLeft: "100px",
            fontWeight: 600,
            // borderColor: "rgba(0, 0, 0, 0.23)",
            backgroundColor: "rgb(249, 164, 77)",
            boxShadow: "none",

            "&:hover": {
              boxShadow: "none",
              backgroundColor: "#fd942a",
            },
          }}
        >
          Download Original
        </Button> */}
        {!isMobileOrTablet ? (
          <Grid2 container spacing={0} height="90vh">
            {/* Main PDF Viewer - full width in mobile horizontal, 10 cols on web */}
            <Grid2 xs={effectiveIsMobileLandscape ? 12 : 10} className="main-container">
              <Grid2
                item
                className={`pdf-container ${isAnnotating ? "custom-cursor" : ""
                  }`}
                ref={pdfContainerRef}
                sx={{
                  height: "100%",
                  overflow: "auto",
                  display: "flex",
                  justifyContent: effectiveIsMobileLandscape ? "flex-start" : "center",
                  padding: effectiveIsMobileLandscape ? "4px" : "10px",
                }}
              // onClick={handlePdfClick} // Enable click for annotations if in annotation mode
              >
                {errorModal === true ||
                  // open === true ||
                  expiredLink === true ||
                  waitforOtherusers === true ? null : (
                  <Box
                    className="pdf-content-box"
                    sx={{
                      width: "100%",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: effectiveIsMobileLandscape ? "flex-start" : "center",
                      minHeight: "100%",
                      transformOrigin: "top center",
                    }}
                  >
                    {pdfImages.length > 0 ? (
                      pdfImages.map((image, index) => (
                        <div
                          key={index}
                          className="pdf-page-container"
                          onMouseEnter={() => handlePageHover(index + 1)}
                          id={`img-${index + 1}`}
                          style={{
                            width: `${calculateImageWidth(scale)}%`,
                            maxWidth: scale > 1 ? "none" : "100%",
                            minWidth: effectiveIsMobileLandscape ? "200px" : "300px",
                            position: "relative",
                            margin: effectiveIsMobileLandscape ? "0 0 20px 0" : "0 auto 20px auto",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <img
                            src={image}
                            alt={`Page ${index + 1}`}
                            className="pdf-image"
                            style={{
                              width: "100%",
                              height: "auto",
                              display: "block",
                              objectFit: "contain",
                              // Remove any height restrictions
                              maxHeight: "none",
                            }}
                          />
                          {/* {renderImage(image, index)} */}
                          {/* Pass the page number directly */}
                          {renderAnnotations(index + 1)}
                        </div>
                      ))
                    ) : (
                      <Typography>Loading PDF...</Typography>
                    )}
                  </Box>
                )}
              </Grid2>
            </Grid2>
            {/* Right Sidebar */}
            <Grid2
              item
              xs={2}
              className="right-sidebar"
              ref={sidebarRef}
              sx={styles.sidebarStyle}
            >
              {errorModal === true ||
                expiredLink === true ||
                waitforOtherusers === true ? null : (
                <>
                  <Typography variant="h6">Preview</Typography>
                  {pdfImages.length > 0 &&
                    pdfImages.map((image, index) => (
                      <>
                        <Box
                          key={index}
                          id={`thumbnail-${index + 1}`}
                          className={`thumbnail-container ${activePage === index + 1 ? "active" : ""
                            }`}
                          onClick={() => {
                            document
                              .getElementById(`img-${index + 1}`)
                              .scrollIntoView({ behavior: "smooth" });
                            setActivePage(index + 1);
                          }}
                        >
                          {renderImage(image, index, false)}
                        </Box>
                        <p
                          className={`page-number ${activePage === index + 1 ? "active" : ""
                            }`}
                        >
                          Page {index + 1}
                        </p>
                      </>
                    ))}{" "}
                </>
              )}
            </Grid2>{" "}
          </Grid2>
        ) : (
          <Grid2
            container
            spacing={0}
            height="90vh"
            style={{
              marginTop: "60px",
              // marginBottom: "100px",
            }}
          >
            {/* Left Sidebar */}

            {/* Main PDF Viewer */}
            <Grid2 xs={12}>
              <Grid2
                className="pdf-wrapper"
                style={{
                  height: "100vh",
                  overflowY: isZoomed ? "hidden" : "auto",
                  overflowX: "hidden",
                  WebkitOverflowScrolling: "touch",
                  scrollBehavior: "smooth",
                  touchAction: isZoomed ? "none" : "pan-y pinch-zoom",
                }}
              >
                <TransformWrapper
                  options={{
                    limitToBounds: false,
                    centerOnInit: false,
                    disablePadding: true,
                    minScale: 0.5,
                    maxScale: 5,
                  }}
                  pinch={{ disabled: false }}
                  panning={{
                    disabled: !isZoomed,
                    velocityDisabled: false,
                    allowLeftClickPan: true,
                    allowRightClickPan: false,
                    allowMiddleClickPan: false,
                  }}
                  wheel={{ disabled: true }}
                  doubleClick={{ disabled: true }}
                  onTransformed={(ref, state) => {
                    const newScale = state.scale;
                    const newIsZoomed = newScale > 1.1; // Small threshold to avoid flickering
                    if (newIsZoomed !== isZoomed) {
                      setIsZoomed(newIsZoomed);
                    }
                  }}
                >
                  <TransformComponent
                    wrapperStyle={{
                      width: "100%",
                      height: "auto",
                      overflow: "visible",
                      touchAction: isZoomed ? "none" : "pan-y pinch-zoom",
                    }}
                    contentStyle={{
                      width: "100%",
                      height: "auto",
                      touchAction: isZoomed ? "none" : "pan-y pinch-zoom",
                    }}
                  >
                    <Grid2
                      item
                      ref={pdfContainerRef}
                      className={`pdf-container ${isAnnotating ? "custom-cursor" : ""
                        }`}
                      style={{
                        width: "100%", // full width
                        // height: "100%", // 🔥 allow growing to match PDF
                        // overflow: "scroll",
                        // height: "100vh", // ✅ allow content height to grow
                        // overflow: "scroll",
                        // touchActions:"pan-y",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column", // ✅ Stack images vertically

                        alignItems: "center",
                      }}
                    >
                      {accessCodeModal === true ||
                        docSignerStatusModal === true ||
                        errorModal === true ||
                        waitforOtherusers === true ? null : (
                        <Box
                          className="pdf-content-box"
                          sx={{
                            minWidth:
                              scale > 1
                                ? `${100 * scale}%`
                                : `${calculateImageWidth(scale)}%`,
                            maxWidth: scale > 1 ? `${100 * scale}%` : "100%",
                            position: "relative",
                            overflow: scale > 1 ? "auto" : "hidden",
                            // minWidth: `${calculateImageWidth(scale)}%`,
                            alignContent: scale <= 1 ? "center" : "flex-start",
                            justifyContent:
                              scale <= 1 ? "center" : "flex-start",
                            alignItems: scale <= 1 ? "center" : "flex-start",
                            display: scale <= 1 ? "flex" : "block",

                            transformOrigin: "top left",
                          }}
                        >
                          {pdfImages.length > 0 ? (
                            pdfImages.map((image, index) => (
                              <div
                                key={index}
                                className="pdf-page-container"
                                onMouseEnter={() => handlePageHover(index + 1)}
                                id={`img-${index + 1}`}
                                style={{
                                  width: `${calculateImageWidth(scale)}%`,
                                  position: "relative",
                                }} // Ensure relative positioning
                              >
                                {renderImage(image, index)}
                                {/* Pass the page number directly */}
                                {renderAnnotations(index + 1)}
                              </div>
                            ))
                          ) : (
                            <Typography>Loading PDF...</Typography>
                          )}
                        </Box>
                      )}
                    </Grid2>
                  </TransformComponent>
                </TransformWrapper>
              </Grid2>
            </Grid2>
          </Grid2>
        )}
        {signatureModalOpen && (
          <Dialog
            key={signatureModalOpen ? `signature-modal-${editingAnnotation?.pageNum}-${editingAnnotation?.index}-${editingAnnotation?.annot?.type}` : "signature-modal-closed"}
            open={signatureModalOpen}
            onClose={(event, reason) => {
              if (reason === "backdropClick" || reason === "escapeKeyDown") return;
              setSignatureModalOpen(false);
              setEditingAnnotation(null);
              setInitialBox(false);
              setLastClickPosition(null);
              setAnnotations((prev) => {
                const next = {};
                for (const page in prev) {
                  if (page === "_lastUpdate") {
                    next[page] = prev[page];
                    continue;
                  }
                  next[page] = Array.isArray(prev[page]) ? prev[page].filter((a) => !a.isLoading) : [];
                }
                return next;
              });
            }}
            disableEscapeKeyDown
            fullScreen={false}
            maxWidth={false}
            slotProps={{
              paper: {
                sx: {
                  width: isMobilePortrait ? "100vw" : isMobileOrTablet ? "100vw" : "100vw",
                  maxWidth: isMobilePortrait ? "100vw" : isMobileOrTablet ? "100vw" : "1200px",
                  height: isMobilePortrait ? "90dvh!important" : isMobileOrTablet ? "85dvh!important" : "70vh!important",
                  maxHeight: isMobilePortrait ? "90dvh!important" : isMobileOrTablet ? "85dvh!important" : "70vh!important",
                  margin: 0,
                  borderRadius: isMobilePortrait ? 0 : "8px",
                  display: "flex",
                  flexDirection: "column",
                  padding: 0,
                  overflow: "hidden",
                  position: "fixed",
                  top: isMobilePortrait ? 0 : isMobileOrTablet ? "5dvh" : "15vh",
                  left: isMobilePortrait ? 0 : isMobileOrTablet ? 0 : "50%",
                  right: isMobilePortrait ? 0 : isMobileOrTablet ? 0 : "auto",
                  bottom: isMobilePortrait ? 0 : "auto",
                  transform: isMobilePortrait || isMobileOrTablet ? "none" : "translateX(-50%)",
                  transition: "all 0.2s ease",
                  zIndex: 20000,
                }
              },
              backdrop: {
                sx: {
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 19999,
                }
              }
            }}
            sx={{
              zIndex: 20000,
              "& .MuiDialog-container": {
                alignItems: isMobilePortrait ? "stretch" : "center",
                justifyContent: isMobilePortrait ? "stretch" : "center",
              },
              "& .MuiDialogTitle-root": {
                padding: isMobileOrTablet ? "12px 16px" : "16px 24px",
                width: "100%",
                boxSizing: "border-box",
                flexShrink: 0,
              },
              "& .MuiDialogContent-root": {
                padding: 0,
                width: "100%!important",
                flex: 1,
                overflow: "hidden",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
              },
            }}
          >
            {signatureModalOpen && (
              <SignatureModalContent
                key={`signature-content-${editingAnnotation?.pageNum}-${editingAnnotation?.index}-${editingAnnotation?.annot?.type}`}
                primaryColorComp={compPrimaryColor}
                modalClosingD={() => {
                  setSignatureModalOpen(false);
                  setEditingAnnotation(null);
                  setInitialBox(false);
                  setLastClickPosition(null);
                  setAnnotations((prev) => {
                    const next = {};
                    for (const page in prev) {
                      if (page === "_lastUpdate") {
                        next[page] = prev[page];
                        continue;
                      }
                      next[page] = Array.isArray(prev[page]) ? prev[page].filter((a) => !a.isLoading) : [];
                    }
                    return next;
                  });
                }}
                receiverSide={true}
                initialsBox={initialsBox}
                profile={false}
                returnedSignature={handleSignatureComplete}
                modalClose={() => {
                  setSignatureModalOpen(false);
                  setEditingAnnotation(null);
                  setInitialBox(false);
                  setLastClickPosition(null);
                  setAnnotations((prev) => {
                    const next = {};
                    for (const page in prev) {
                      if (page === "_lastUpdate") {
                        next[page] = prev[page];
                        continue;
                      }
                      next[page] = Array.isArray(prev[page]) ? prev[page].filter((a) => !a.isLoading) : [];
                    }
                    return next;
                  });
                }}
                user_id_user={user_idSender}
                user_email={userEmailSender}
                existingSignatureUrl={null}
              />
            )}
          </Dialog>
        )}
      </Box>
      {/* // Add this instead (place it next to your other Dialog components): */}
      <Dialog
        open={cropperModalOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setCropperModalOpen(false);
          setCropSrc(null);
          setPendingStampAction(null);
          setStampClickPosition(null);
          setEditingAnnotation(null);
        }}
        disableEscapeKeyDown
        maxWidth={isMobileOrTablet ? false : "md"}
        fullWidth
        fullScreen={false}
        sx={{
          zIndex: 20000,
          "& .MuiDialog-paper": {
            margin: isMobileOrTablet ? "20px 0 0 0" : undefined,
            maxWidth: isMobileOrTablet ? "100%" : undefined,
            maxHeight: isMobileOrTablet ? "calc(100vh - 20px)" : undefined,
            height: isMobileOrTablet ? "calc(100vh - 20px)" : undefined,
            width: isMobileOrTablet ? "100%" : undefined,
            zIndex: 20000,
          },
          "& .MuiBackdrop-root": {
            zIndex: 19999,
          },
        }}
      >
        <DialogTitle
          sx={{
            flexShrink: 0,
            padding: isMobileOrTablet ? "20px 16px" : "24px 24px 16px 24px",
            fontSize: isMobileOrTablet ? "20px" : "24px",
            fontWeight: 600,
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#fff",
          }}
        >
          Crop Image
          <IconButton
            aria-label="close"
            onClick={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
              setEditingAnnotation(null);
            }}
            sx={{
              position: "absolute",
              right: isMobileOrTablet ? 12 : 16,
              top: isMobileOrTablet ? 16 : 20,
              color: "#666",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            padding: isMobileOrTablet ? "16px" : "24px",
            overflow: "hidden",
            minHeight: 0,
            position: "relative",
            backgroundColor: isMobileOrTablet ? "#f5f5f5" : "#fff",
          }}
        >
          <ImageCropperModal
            cropSrc={cropSrc}
            isOpen={cropperModalOpen}
            isMobile={isMobileOrTablet}
            toggle={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
              setEditingAnnotation(null);
            }}
            onImageCropped={handleCroppedStamp}
          />
        </DialogContent>
      </Dialog>
      {/* // Add the SignersDialog component in your return statement (near other dialogs) */}
      <SignersDialog
        open={signersDialogOpen}
        onClose={() => {
          setSignersDialogOpen(false);
          setSignerToEdit(null); // Clear edit state on close
        }}
        signers={signers}
        file_id={documentId}
        setSigners={setSigners}
        signerToEdit={signerToEdit}
      />
      <AccessCodeDialog
        accessCodeModalData={() => {
          console.log("agasdcfasdfgcfgasc");
          setAccessCodeModal(false);
        }}
        accessCodeModal={waitforOtherusers ? false : accessCodeModal}
        accessCodeSigner={accessCodeSigner}
      />
      <CompletionModal open={docSignerStatusModal} />
      <ErrorModal open={errorModal} />
      <ExpiredLinkModal open={expiredLink} />
      <WaitForOthersDialog open={waitforOtherusers} signers={signers} />
      <VerificationDialog
        logo={compLogo}
        primaryColorComp={compPrimaryColor}
        open={open}
        setOpen={setOpen}
        needsVerification={verificationNeeded}
        fileId={file_id}
        welcomeMessage={welcomeMessage}
        acknowledgementMessage={acknowledgmentMessage}
        companyName={senderCompanyName}
        callbackData={async (data) => {
          console.log("data", data);
          setCurrentSignerEmail(data?.email);
          setCurrentSignerName(data?.name);
          let response_log = await getActivityLogUserBulk({
            file_id: file_id,
            email: data?.email,
            event: "OPEN-DOCUMENT",
            // response_get: true,
            description: `${data?.email} open a public form ${fileName} `,
            user_shared_email: data?.email,
          });
          if (response_log === null) {
            console.log("MAINTAIN ERROR LOG");
          } else {
            console.log("MAINTAIN SUCCESS LOG");
            console.log(response_log);
            // response_log1 = response_log;
          }
        }}
        compId={null}
      />
      <Dialog
        open={ResponseLimitCompleted} // ✅ Opens when limit is reached
        fullScreen // ✅ Forces full-screen modal
        disableEscapeKeyDown // ✅ Prevents closing via "Esc"
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            height: "100%",
            margin: 0,
            borderRadius: 0, // ✅ Ensures fullscreen effect
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            bgcolor: "white", // Adjust background if needed
          }}
        >
          <Box sx={{ mb: 3 }}>
            <ErrorOutlineIcon sx={{ fontSize: 80, color: "red" }} />
          </Box>

          <DialogTitle sx={{ fontSize: 24, fontWeight: "bold" }}>
            Response Limit Reached
          </DialogTitle>
          <Typography sx={{ color: "#666", maxWidth: "400px", mt: 1 }}>
            Sorry, this form has reached its maximum number of responses.
          </Typography>
        </DialogContent>
      </Dialog>
      <Dialog
        open={modalOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setModalOpen(false);
        }}
        disableEscapeKeyDown
        fullWidth
        maxWidth={annotationType === "signer_date" ? false : "lg"}
        sx={{
          zIndex: 20000,
          "& .MuiDialog-paper": {
            width: annotationType === "signer_date" ? (isMobileOrTablet ? "95%" : "700px") : "98%",
            height: annotationType === "signer_date" ? (isMobileOrTablet ? "auto" : "520px") : undefined,
            maxHeight: annotationType === "signer_date" && isMobileOrTablet ? "90vh" : undefined,
            maxWidth: annotationType === "signer_date" ? "none" : "none",
            margin: isMobileOrTablet ? "5px" : "10px",
            position: "absolute",
            top: annotationType === "signer_date" ? "5%" : "10%",
            transform: "translate(0, 0)",
            display: "flex",
            flexDirection: "column",
            justifyContent: annotationType === "signer_date" && isMobileOrTablet ? "flex-start" : "center",
            alignItems: "center",
            overflow: "visible",
            zIndex: 20000,
            ...(annotationType === "signer_date" && {
              borderRadius: isMobileOrTablet ? 16 : 20,
              boxShadow: "0 24px 48px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.08)",
            }),
          },
          "& .MuiBackdrop-root": {
            zIndex: 19999,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            fontSize: isMobileOrTablet ? "1.1rem" : "1.25rem",
            paddingBottom: annotationType === "signer_date" ? 2 : 1,
            borderBottom: annotationType === "signer_date" ? "1px solid rgba(0, 0, 0, 0.08)" : "none",
          }}
        >
          {annotationType === "signer_dropdown"
            ? "Select an Option"
            : annotationType === "signer_date"
              ? "Select Date"
              : "Enter Text"}
        </DialogTitle>
        <DialogContent
          sx={{
            ...(annotationType === "signer_date" && {
              padding: isMobileOrTablet ? "16px 20px 8px" : "24px 28px 8px",
              maxHeight: isMobileOrTablet ? "85vh" : "none",
              overflow: "visible",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              "& .react-datepicker": {
                fontSize: isMobileOrTablet ? "14px" : "16px",
                fontFamily: "inherit",
              },
              "& .react-datepicker__month-container": {
                width: "100%",
              },
              "& .react-datepicker__day": {
                width: isMobileOrTablet ? "32px" : "36px",
                height: isMobileOrTablet ? "32px" : "36px",
                lineHeight: isMobileOrTablet ? "32px" : "36px",
                fontSize: isMobileOrTablet ? "14px" : "15px",
                borderRadius: "8px",
              },
              "& .react-datepicker__day--selected": {
                borderRadius: "8px",
                fontWeight: 600,
              },
              "& .react-datepicker__day--keyboard-selected": {
                borderRadius: "8px",
              },
              "& .react-datepicker__header": {
                paddingTop: isMobileOrTablet ? "8px" : "12px",
                paddingBottom: "8px",
              },
              "& .react-datepicker__current-month": {
                fontSize: isMobileOrTablet ? "1rem" : "1.1rem",
                fontWeight: 600,
              },
            }),
          }}
        >
          {annotationType === "signer_dropdown" ? (
            <Select
              fullWidth
              value={inputValue}
              // onChange={(e) => setInputValue(e.target.value)}
              onChange={(e) => {
                const newValue = e.target.value;
                setInputValue(newValue);

                // Update annotation's selectedOption
                if (activeAnnot) {
                  const { pageNum, index } = activeAnnot;
                  setAnnotations((prev) => {
                    const updatedAnnotations = { ...prev };
                    updatedAnnotations[pageNum][index] = {
                      ...updatedAnnotations[pageNum][index],
                      selectedOption: newValue,
                    };
                    return updatedAnnotations;
                  });
                }
              }}
            >
              {dropdownOptions.length > 0 ? (
                dropdownOptions.map((option, idx) => (
                  <MenuItem key={idx} value={option}>
                    {option}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No options</MenuItem>
              )}
            </Select>
          ) : annotationType === "signer_date" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <DatePicker
                selected={(() => {
                  if (!inputValue || inputValue === "Date" || inputValue === "Date..." || inputValue === "Select a date") {
                    return null;
                  }
                  try {
                    const parsedDate = parse(inputValue, "MMM dd, yyyy", new Date());
                    return isValid(parsedDate) ? parsedDate : null;
                  } catch (error) {
                    const directDate = new Date(inputValue);
                    return isValid(directDate) ? directDate : null;
                  }
                })()}
                onChange={(date) => {
                  if (date && isValid(date)) {
                    setInputValue(format(new Date(date), "MMM dd, yyyy"));
                  }
                }}
                dateFormat="MMM dd, yyyy"
                className="custom-datepicker"
                inline={true}
                minDate={new Date()}
                filterDate={(date) => date >= new Date(new Date().setHours(0, 0, 0, 0))}
              />
            </Box>
          ) : (
            <TextField
              fullWidth
              autoFocus
              variant="outlined"
              value={inputValue}
              // onChange={(e) => setInputValue(e.target.value)}
              onChange={handleDialogInputChange}
              placeholder="Type here..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // handleSaveInput();
                  setModalOpen(false);
                }
              }}
              inputProps={{ maxLength: maxChars }} // Restrict input length
            />
          )}
        </DialogContent>
        <DialogActions
          sx={{
            padding: annotationType === "signer_date" ? "16px 24px 20px" : undefined,
            gap: 1.5,
            borderTop: annotationType === "signer_date" ? "1px solid rgba(0, 0, 0, 0.08)" : "none",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => setModalOpen(false)}
            variant={annotationType === "signer_date" || annotationType === "signer_dropdown" ? "outlined" : "text"}
            sx={{
              fontSize: isMobileOrTablet ? "14px" : "15px",
              padding: isMobileOrTablet ? "10px 20px" : "10px 24px",
              minWidth: isMobileOrTablet ? 88 : 100,
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              ...((annotationType === "signer_date" || annotationType === "signer_dropdown") && {
                borderColor: "rgba(0, 0, 0, 0.23)",
                color: "rgba(0, 0, 0, 0.87)",
                "&:hover": {
                  borderColor: "rgba(0, 0, 0, 0.4)",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveInput}
            sx={{
              fontSize: isMobileOrTablet ? "14px" : "15px",
              padding: isMobileOrTablet ? "10px 20px" : "10px 24px",
              minWidth: isMobileOrTablet ? 88 : 100,
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0, 51, 153, 0.25)",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(0, 51, 153, 0.35)",
              },
            }}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
      {/* Text entry modal - same as EsignReceivingEnd (box + dialog for text fields) */}
      <TextEntryDialog
        open={textEntryDialogOpen}
        onClose={handleTextEntryCancel}
        onDone={handleTextEntryComplete}
        initialText={textEntryInitialText}
        placeholderText={textEntryPlaceholder}
        showCharacterCount={false}
        submitOnEnter={true}
      />
    </>
  );
}

export default EsignReceivingEndPublicForm;
